export const CITY = {
	CITYS:[
    {
        "index": "A",
        "citys": [
            {
                "zip": "0837",
                "pinyin": "Aba",
                "name": "阿坝",
                "label": "阿坝Aba0837"
            },
            {
                "zip": "0997",
                "pinyin": "Akesu",
                "name": "阿克苏",
                "label": "阿克苏Akesu0997"
            },
            {
                "zip": "0483",
                "pinyin": "Alashanmeng",
                "name": "阿拉善盟",
                "label": "阿拉善盟Alashanmeng0483"
            },
            {
                "zip": "0906",
                "pinyin": "Aletai",
                "name": "阿勒泰",
                "label": "阿勒泰Aletai0906"
            },
            {
                "zip": "0897",
                "pinyin": "Ali",
                "name": "阿里",
                "label": "阿里Ali0897"
            },
            {
                "zip": "0915",
                "pinyin": "Ankang",
                "name": "安康",
                "label": "安康Ankang0915"
            },
            {
                "zip": "0556",
                "pinyin": "Anqing",
                "name": "安庆",
                "label": "安庆Anqing0556"
            },
            {
                "zip": "0412",
                "pinyin": "Anshan",
                "name": "鞍山",
                "label": "鞍山Anshan0412"
            },
            {
                "zip": "0853",
                "pinyin": "Anshun",
                "name": "安顺",
                "label": "安顺Anshun0853"
            },
            {
                "zip": "0372",
                "pinyin": "Anyang",
                "name": "安阳",
                "label": "安阳Anyang0372"
            },
            {
                "zip": "0451",
                "pinyin": "Acheng",
                "name": "阿城",
                "label": "阿城Acheng0451"
            },
            {
                "zip": "0796",
                "pinyin": "Anfu",
                "name": "安福",
                "label": "安福Anfu0796"
            },
            {
                "zip": "0572",
                "pinyin": "Anji",
                "name": "安吉",
                "label": "安吉Anji0572"
            },
            {
                "zip": "0871",
                "pinyin": "Anning",
                "name": "安宁",
                "label": "安宁Anning0871"
            },
            {
                "zip": "0536",
                "pinyin": "Anqiu",
                "name": "安丘",
                "label": "安丘Anqiu0536"
            },
            {
                "zip": "0595",
                "pinyin": "Anxi",
                "name": "安溪",
                "label": "安溪Anxi0595"
            },
            {
                "zip": "0791",
                "pinyin": "Anyi",
                "name": "安义",
                "label": "安义Anyi0791"
            },
            {
                "zip": "0797",
                "pinyin": "Anyuan",
                "name": "安远",
                "label": "安远Anyuan0797"
            }
        ]
    },
    {
        "index": "B",
        "citys": [
            {
                "zip": "010",
                "pinyin": "Beijing",
                "name": "北京",
                "label": "北京Beijing010"
            },
            {
                "zip": "0436",
                "pinyin": "Baicheng",
                "name": "白城",
                "label": "白城Baicheng0436"
            },
            {
                "zip": "0776",
                "pinyin": "Baise",
                "name": "百色",
                "label": "百色Baise0776"
            },
            {
                "zip": "0439",
                "pinyin": "Baishan",
                "name": "白山",
                "label": "白山Baishan0439"
            },
            {
                "zip": "0943",
                "pinyin": "Baiyin",
                "name": "白银",
                "label": "白银Baiyin0943"
            },
            {
                "zip": "0552",
                "pinyin": "Bangbu",
                "name": "蚌埠",
                "label": "蚌埠Bangbu0552"
            },
            {
                "zip": "0312",
                "pinyin": "Baoding",
                "name": "保定",
                "label": "保定Baoding0312"
            },
            {
                "zip": "0917",
                "pinyin": "Baoji",
                "name": "宝鸡",
                "label": "宝鸡Baoji0917"
            },
            {
                "zip": "0875",
                "pinyin": "Baoshan",
                "name": "保山",
                "label": "保山Baoshan0875"
            },
            {
                "zip": "0472",
                "pinyin": "Baotou",
                "name": "包头",
                "label": "包头Baotou0472"
            },
            {
                "zip": "0478",
                "pinyin": "Bayannaoer",
                "name": "巴彦淖尔",
                "label": "巴彦淖尔Bayannaoer0478"
            },
            {
                "zip": "0996",
                "pinyin": "Bayinguoleng",
                "name": "巴音郭楞",
                "label": "巴音郭楞Bayinguoleng0996"
            },
            {
                "zip": "0827",
                "pinyin": "Bazhong",
                "name": "巴中",
                "label": "巴中Bazhong0827"
            },
            {
                "zip": "0779",
                "pinyin": "Beihai",
                "name": "北海",
                "label": "北海Beihai0779"
            },
            {
                "zip": "0414",
                "pinyin": "Benxi",
                "name": "本溪",
                "label": "本溪Benxi0414"
            },
            {
                "zip": "0857",
                "pinyin": "Bijie",
                "name": "毕节",
                "label": "毕节Bijie0857"
            },
            {
                "zip": "0543",
                "pinyin": "Binzhou",
                "name": "滨州",
                "label": "滨州Binzhou0543"
            },
            {
                "zip": "0909",
                "pinyin": "Boertala",
                "name": "博尔塔拉",
                "label": "博尔塔拉Boertala0909"
            },
            {
                "zip": "0558",
                "pinyin": "Bozhou",
                "name": "亳州",
                "label": "亳州Bozhou0558"
            },
            {
                "zip": "0514",
                "pinyin": "Baoying",
                "name": "宝应",
                "label": "宝应Baoying0514"
            },
            {
                "zip": "0451",
                "pinyin": "Bayan",
                "name": "巴彦",
                "label": "巴彦Bayan0451"
            },
            {
                "zip": "0515",
                "pinyin": "Binhai",
                "name": "滨海",
                "label": "滨海Binhai0515"
            },
            {
                "zip": "0451",
                "pinyin": "Binxian",
                "name": "宾县",
                "label": "宾县Binxian0451"
            },
            {
                "zip": "0771",
                "pinyin": "Binyang",
                "name": "宾阳",
                "label": "宾阳Binyang0771"
            },
            {
                "zip": "023",
                "pinyin": "Bishan",
                "name": "璧山",
                "label": "璧山Bishan023"
            },
            {
                "zip": "0391",
                "pinyin": "Boai",
                "name": "博爱",
                "label": "博爱Boai0391"
            },
            {
                "zip": "0752",
                "pinyin": "Boluo",
                "name": "博罗",
                "label": "博罗Boluo0752"
            },
            {
                "zip": "0543",
                "pinyin": "Boxing",
                "name": "博兴",
                "label": "博兴Boxing0543"
            }
        ]
    },
    {
        "index": "C",
        "citys": [
            {
                "zip": "023",
                "pinyin": "Chongqing",
                "name": "重庆",
                "label": "重庆Chongqing023"
            },
            {
                "zip": "0431",
                "pinyin": "Changchun",
                "name": "长春",
                "label": "长春Changchun0431"
            },
            {
                "zip": "0731",
                "pinyin": "Changsha",
                "name": "长沙",
                "label": "长沙Changsha0731"
            },
            {
                "zip": "0519",
                "pinyin": "Changzhou",
                "name": "常州",
                "label": "常州Changzhou0519"
            },
            {
                "zip": "028",
                "pinyin": "Chengdu",
                "name": "成都",
                "label": "成都Chengdu028"
            },
            {
                "zip": "0317",
                "pinyin": "Cangzhou",
                "name": "沧州",
                "label": "沧州Cangzhou0317"
            },
            {
                "zip": "0736",
                "pinyin": "Changde",
                "name": "常德",
                "label": "常德Changde0736"
            },
            {
                "zip": "0895",
                "pinyin": "Changdu",
                "name": "昌都",
                "label": "昌都Changdu0895"
            },
            {
                "zip": "0997",
                "pinyin": "Changji",
                "name": "昌吉",
                "label": "昌吉Changji0997"
            },
            {
                "zip": "0355",
                "pinyin": "Changzhi",
                "name": "长治",
                "label": "长治Changzhi0355"
            },
            {
                "zip": "0565",
                "pinyin": "Chaohu",
                "name": "巢湖",
                "label": "巢湖Chaohu0565"
            },
            {
                "zip": "0421",
                "pinyin": "Chaoyang",
                "name": "朝阳",
                "label": "朝阳Chaoyang0421"
            },
            {
                "zip": "0768",
                "pinyin": "Chaozhou",
                "name": "潮州",
                "label": "潮州Chaozhou0768"
            },
            {
                "zip": "0314",
                "pinyin": "Chengde",
                "name": "承德",
                "label": "承德Chengde0314"
            },
            {
                "zip": "0735",
                "pinyin": "Chenzhou",
                "name": "郴州",
                "label": "郴州Chenzhou0735"
            },
            {
                "zip": "0476",
                "pinyin": "Chifeng",
                "name": "赤峰",
                "label": "赤峰Chifeng0476"
            },
            {
                "zip": "0566",
                "pinyin": "Chizhou",
                "name": "池州",
                "label": "池州Chizhou0566"
            },
            {
                "zip": "0771",
                "pinyin": "Chongzuo",
                "name": "崇左",
                "label": "崇左Chongzuo0771"
            },
            {
                "zip": "0875",
                "pinyin": "Chuxiong",
                "name": "楚雄",
                "label": "楚雄Chuxiong0875"
            },
            {
                "zip": "0550",
                "pinyin": "Chuzhou",
                "name": "滁州",
                "label": "滁州Chuzhou0550"
            },
            {
                "zip": "0577",
                "pinyin": "Cangnan",
                "name": "苍南",
                "label": "苍南Cangnan0577"
            },
            {
                "zip": "0539",
                "pinyin": "Cangshan",
                "name": "苍山",
                "label": "苍山Cangshan0539"
            },
            {
                "zip": "0530",
                "pinyin": "Caoxian",
                "name": "曹县",
                "label": "曹县Caoxian0530"
            },
            {
                "zip": "0535",
                "pinyin": "Changdao",
                "name": "长岛",
                "label": "长岛Changdao0535"
            },
            {
                "zip": "0551",
                "pinyin": "Changfeng",
                "name": "长丰",
                "label": "长丰Changfeng0551"
            },
            {
                "zip": "0411",
                "pinyin": "Changhai",
                "name": "长海",
                "label": "长海Changhai0411"
            },
            {
                "zip": "0591",
                "pinyin": "Changle",
                "name": "长乐",
                "label": "长乐Changle0591"
            },
            {
                "zip": "0536",
                "pinyin": "Changle",
                "name": "昌乐",
                "label": "昌乐Changle0536"
            },
            {
                "zip": "0570",
                "pinyin": "Changshan",
                "name": "常山",
                "label": "常山Changshan0570"
            },
            {
                "zip": "0512",
                "pinyin": "Changshu",
                "name": "常熟",
                "label": "常熟Changshu0512"
            },
            {
                "zip": "0596",
                "pinyin": "Changtai",
                "name": "长泰",
                "label": "长泰Changtai0596"
            },
            {
                "zip": "0597",
                "pinyin": "Changting",
                "name": "长汀",
                "label": "长汀Changting0597"
            },
            {
                "zip": "0572",
                "pinyin": "Changxing",
                "name": "长兴",
                "label": "长兴Changxing0572"
            },
            {
                "zip": "0536",
                "pinyin": "Changyi",
                "name": "昌邑",
                "label": "昌邑Changyi0536"
            },
            {
                "zip": "0768",
                "pinyin": "Chaoan",
                "name": "潮安",
                "label": "潮安Chaoan0768"
            },
            {
                "zip": "0871",
                "pinyin": "Chenggong",
                "name": "呈贡",
                "label": "呈贡Chenggong0871"
            },
            {
                "zip": "023",
                "pinyin": "Chengkou",
                "name": "城口",
                "label": "城口Chengkou023"
            },
            {
                "zip": "0530",
                "pinyin": "Chengwu",
                "name": "成武",
                "label": "成武Chengwu0530"
            },
            {
                "zip": "0635",
                "pinyin": "Chiping",
                "name": "茌平",
                "label": "茌平Chiping0635"
            },
            {
                "zip": "0794",
                "pinyin": "Chongren",
                "name": "崇仁",
                "label": "崇仁Chongren0794"
            },
            {
                "zip": "0797",
                "pinyin": "Chongyi",
                "name": "崇义",
                "label": "崇义Chongyi0797"
            },
            {
                "zip": "028",
                "pinyin": "Chongzhou",
                "name": "崇州",
                "label": "崇州Chongzhou028"
            },
            {
                "zip": "0571",
                "pinyin": "Chunan",
                "name": "淳安",
                "label": "淳安Chunan0571"
            },
            {
                "zip": "0574",
                "pinyin": "Cixi",
                "name": "慈溪",
                "label": "慈溪Cixi0574"
            },
            {
                "zip": "020",
                "pinyin": "Conghua",
                "name": "从化",
                "label": "从化Conghua020"
            },
            {
                "zip": "0556",
                "pinyin": "Congyang",
                "name": "枞阳",
                "label": "枞阳Congyang0556"
            }
        ]
    },
    {
        "index": "D",
        "citys": [
            {
                "zip": "0411",
                "pinyin": "Dalian",
                "name": "大连",
                "label": "大连Dalian0411"
            },
            {
                "zip": "0769",
                "pinyin": "Dongguan",
                "name": "东莞",
                "label": "东莞Dongguan0769"
            },
            {
                "zip": "0872",
                "pinyin": "Dali",
                "name": "大理",
                "label": "大理Dali0872"
            },
            {
                "zip": "0415",
                "pinyin": "Dandong",
                "name": "丹东",
                "label": "丹东Dandong0415"
            },
            {
                "zip": "0459",
                "pinyin": "Daqing",
                "name": "大庆",
                "label": "大庆Daqing0459"
            },
            {
                "zip": "0352",
                "pinyin": "Datong",
                "name": "大同",
                "label": "大同Datong0352"
            },
            {
                "zip": "0457",
                "pinyin": "Daxinganling",
                "name": "大兴安岭",
                "label": "大兴安岭Daxinganling0457"
            },
            {
                "zip": "0818",
                "pinyin": "Dazhou",
                "name": "达州",
                "label": "达州Dazhou0818"
            },
            {
                "zip": "0692",
                "pinyin": "Dehong",
                "name": "德宏",
                "label": "德宏Dehong0692"
            },
            {
                "zip": "0838",
                "pinyin": "Deyang",
                "name": "德阳",
                "label": "德阳Deyang0838"
            },
            {
                "zip": "0534",
                "pinyin": "Dezhou",
                "name": "德州",
                "label": "德州Dezhou0534"
            },
            {
                "zip": "0932",
                "pinyin": "Dingxi",
                "name": "定西",
                "label": "定西Dingxi0932"
            },
            {
                "zip": "0887",
                "pinyin": "Diqing",
                "name": "迪庆",
                "label": "迪庆Diqing0887"
            },
            {
                "zip": "0546",
                "pinyin": "Dongying",
                "name": "东营",
                "label": "东营Dongying0546"
            },
            {
                "zip": "0515",
                "pinyin": "Dafeng",
                "name": "大丰",
                "label": "大丰Dafeng0515"
            },
            {
                "zip": "0580",
                "pinyin": "Daishan",
                "name": "岱山",
                "label": "岱山Daishan0580"
            },
            {
                "zip": "0557",
                "pinyin": "Dangshan",
                "name": "砀山",
                "label": "砀山Dangshan0557"
            },
            {
                "zip": "0555",
                "pinyin": "Dangtu",
                "name": "当涂",
                "label": "当涂Dangtu0555"
            },
            {
                "zip": "0530",
                "pinyin": "Danxian",
                "name": "单县",
                "label": "单县Danxian0530"
            },
            {
                "zip": "0511",
                "pinyin": "Danyang",
                "name": "丹阳",
                "label": "丹阳Danyang0511"
            },
            {
                "zip": "0753",
                "pinyin": "Dapu",
                "name": "大埔",
                "label": "大埔Dapu0753"
            },
            {
                "zip": "0598",
                "pinyin": "Datian",
                "name": "大田",
                "label": "大田Datian0598"
            },
            {
                "zip": "028",
                "pinyin": "Dayi",
                "name": "大邑",
                "label": "大邑Dayi028"
            },
            {
                "zip": "0797",
                "pinyin": "Dayu",
                "name": "大余",
                "label": "大余Dayu0797"
            },
            {
                "zip": "023",
                "pinyin": "Dazu",
                "name": "大足",
                "label": "大足Dazu023"
            },
            {
                "zip": "0792",
                "pinyin": "Dean",
                "name": "德安",
                "label": "德安Dean0792"
            },
            {
                "zip": "0595",
                "pinyin": "Dehua",
                "name": "德化",
                "label": "德化Dehua0595"
            },
            {
                "zip": "0431",
                "pinyin": "Dehui",
                "name": "德惠",
                "label": "德惠Dehui0431"
            },
            {
                "zip": "0371",
                "pinyin": "Dengfeng",
                "name": "登封",
                "label": "登封Dengfeng0371"
            },
            {
                "zip": "0572",
                "pinyin": "Deqing",
                "name": "德清",
                "label": "德清Deqing0572"
            },
            {
                "zip": "0758",
                "pinyin": "Deqing",
                "name": "德庆",
                "label": "德庆Deqing0758"
            },
            {
                "zip": "0793",
                "pinyin": "Dexing",
                "name": "德兴",
                "label": "德兴Dexing0793"
            },
            {
                "zip": "0668",
                "pinyin": "Dianbai",
                "name": "电白",
                "label": "电白Dianbai0668"
            },
            {
                "zip": "023",
                "pinyin": "Dianjiang",
                "name": "垫江",
                "label": "垫江Dianjiang023"
            },
            {
                "zip": "0797",
                "pinyin": "Dingnan",
                "name": "定南",
                "label": "定南Dingnan0797"
            },
            {
                "zip": "0530",
                "pinyin": "Dingtao",
                "name": "定陶",
                "label": "定陶Dingtao0530"
            },
            {
                "zip": "0550",
                "pinyin": "Dingyuan",
                "name": "定远",
                "label": "定远Dingyuan0550"
            },
            {
                "zip": "0635",
                "pinyin": "Donga",
                "name": "东阿",
                "label": "东阿Donga0635"
            },
            {
                "zip": "0518",
                "pinyin": "Donghai",
                "name": "东海",
                "label": "东海Donghai0518"
            },
            {
                "zip": "0530",
                "pinyin": "Dongming",
                "name": "东明",
                "label": "东明Dongming0530"
            },
            {
                "zip": "0538",
                "pinyin": "Dongping",
                "name": "东平",
                "label": "东平Dongping0538"
            },
            {
                "zip": "0596",
                "pinyin": "Dongshan",
                "name": "东山",
                "label": "东山Dongshan0596"
            },
            {
                "zip": "0515",
                "pinyin": "Dongtai",
                "name": "东台",
                "label": "东台Dongtai0515"
            },
            {
                "zip": "0577",
                "pinyin": "Dongtou",
                "name": "洞头",
                "label": "洞头Dongtou0577"
            },
            {
                "zip": "0794",
                "pinyin": "Dongxiang",
                "name": "东乡",
                "label": "东乡Dongxiang0794"
            },
            {
                "zip": "0579",
                "pinyin": "Dongyang",
                "name": "东阳",
                "label": "东阳Dongyang0579"
            },
            {
                "zip": "0762",
                "pinyin": "Dongyuan",
                "name": "东源",
                "label": "东源Dongyuan0762"
            },
            {
                "zip": "0566",
                "pinyin": "Dongzhi",
                "name": "东至",
                "label": "东至Dongzhi0566"
            },
            {
                "zip": "0792",
                "pinyin": "Duchang",
                "name": "都昌",
                "label": "都昌Duchang0792"
            },
            {
                "zip": "028",
                "pinyin": "Dujiangyan",
                "name": "都江堰",
                "label": "都江堰Dujiangyan028"
            }
        ]
    },
    {
        "index": "E",
        "citys": [
            {
                "zip": "0477",
                "pinyin": "Eerduosi",
                "name": "鄂尔多斯",
                "label": "鄂尔多斯Eerduosi0477"
            },
            {
                "zip": "0718",
                "pinyin": "Enshi",
                "name": "恩施",
                "label": "恩施Enshi0718"
            },
            {
                "zip": "0711",
                "pinyin": "Ezhou",
                "name": "鄂州",
                "label": "鄂州Ezhou0711"
            },
            {
                "zip": "0750",
                "pinyin": "Enping",
                "name": "恩平",
                "label": "恩平Enping0750"
            }
        ]
    },
    {
        "index": "F",
        "citys": [
            {
                "zip": "0757",
                "pinyin": "Foshan",
                "name": "佛山",
                "label": "佛山Foshan0757"
            },
            {
                "zip": "0591",
                "pinyin": "Fuzhou",
                "name": "福州",
                "label": "福州Fuzhou0591"
            },
            {
                "zip": "0770",
                "pinyin": "Fangchenggang",
                "name": "防城港",
                "label": "防城港Fangchenggang0770"
            },
            {
                "zip": "0413",
                "pinyin": "Fushun",
                "name": "抚顺",
                "label": "抚顺Fushun0413"
            },
            {
                "zip": "0418",
                "pinyin": "Fuxin",
                "name": "阜新",
                "label": "阜新Fuxin0418"
            },
            {
                "zip": "0558",
                "pinyin": "Fuyang",
                "name": "阜阳",
                "label": "阜阳Fuyang0558"
            },
            {
                "zip": "0794",
                "pinyin": "Fuzhou",
                "name": "抚州",
                "label": "抚州Fuzhou0794"
            },
            {
                "zip": "024",
                "pinyin": "Faku",
                "name": "法库",
                "label": "法库Faku024"
            },
            {
                "zip": "0553",
                "pinyin": "Fanchang",
                "name": "繁昌",
                "label": "繁昌Fanchang0553"
            },
            {
                "zip": "0451",
                "pinyin": "Fangzheng",
                "name": "方正",
                "label": "方正Fangzheng0451"
            },
            {
                "zip": "0538",
                "pinyin": "Feicheng",
                "name": "肥城",
                "label": "肥城Feicheng0538"
            },
            {
                "zip": "0551",
                "pinyin": "Feidong",
                "name": "肥东",
                "label": "肥东Feidong0551"
            },
            {
                "zip": "0551",
                "pinyin": "Feixi",
                "name": "肥西",
                "label": "肥西Feixi0551"
            },
            {
                "zip": "0539",
                "pinyin": "Feixian",
                "name": "费县",
                "label": "费县Feixian0539"
            },
            {
                "zip": "0795",
                "pinyin": "Fengcheng",
                "name": "丰城",
                "label": "丰城Fengcheng0795"
            },
            {
                "zip": "023",
                "pinyin": "Fengdu",
                "name": "丰都",
                "label": "丰都Fengdu023"
            },
            {
                "zip": "0574",
                "pinyin": "Fenghua",
                "name": "奉化",
                "label": "奉化Fenghua0574"
            },
            {
                "zip": "023",
                "pinyin": "Fengjie",
                "name": "奉节",
                "label": "奉节Fengjie023"
            },
            {
                "zip": "0758",
                "pinyin": "Fengkai",
                "name": "封开",
                "label": "封开Fengkai0758"
            },
            {
                "zip": "0753",
                "pinyin": "Fengshun",
                "name": "丰顺",
                "label": "丰顺Fengshun0753"
            },
            {
                "zip": "0554",
                "pinyin": "Fengtai",
                "name": "凤台",
                "label": "凤台Fengtai0554"
            },
            {
                "zip": "0516",
                "pinyin": "Fengxian",
                "name": "丰县",
                "label": "丰县Fengxian0516"
            },
            {
                "zip": "0795",
                "pinyin": "Fengxin",
                "name": "奉新",
                "label": "奉新Fengxin0795"
            },
            {
                "zip": "0550",
                "pinyin": "Fengyang",
                "name": "凤阳",
                "label": "凤阳Fengyang0550"
            },
            {
                "zip": "0790",
                "pinyin": "Fenyi",
                "name": "分宜",
                "label": "分宜Fenyi0790"
            },
            {
                "zip": "0763",
                "pinyin": "Fogang",
                "name": "佛冈",
                "label": "佛冈Fogang0763"
            },
            {
                "zip": "0593",
                "pinyin": "Fuan",
                "name": "福安",
                "label": "福安Fuan0593"
            },
            {
                "zip": "0593",
                "pinyin": "Fuding",
                "name": "福鼎",
                "label": "福鼎Fuding0593"
            },
            {
                "zip": "0798",
                "pinyin": "Fuliang",
                "name": "浮梁",
                "label": "浮梁Fuliang0798"
            },
            {
                "zip": "0871",
                "pinyin": "Fumin",
                "name": "富民",
                "label": "富民Fumin0871"
            },
            {
                "zip": "0558",
                "pinyin": "Funan",
                "name": "阜南",
                "label": "阜南Funan0558"
            },
            {
                "zip": "0515",
                "pinyin": "Funing",
                "name": "阜宁",
                "label": "阜宁Funing0515"
            },
            {
                "zip": "0591",
                "pinyin": "Fuqing",
                "name": "福清",
                "label": "福清Fuqing0591"
            },
            {
                "zip": "0571",
                "pinyin": "Fuyang",
                "name": "富阳",
                "label": "富阳Fuyang0571"
            }
        ]
    },
    {
        "index": "G",
        "citys": [
            {
                "zip": "020",
                "pinyin": "Guangzhou",
                "name": "广州",
                "label": "广州Guangzhou020"
            },
            {
                "zip": "0851",
                "pinyin": "Guiyang",
                "name": "贵阳",
                "label": "贵阳Guiyang0851"
            },
            {
                "zip": "0941",
                "pinyin": "Gannan",
                "name": "甘南",
                "label": "甘南Gannan0941"
            },
            {
                "zip": "0797",
                "pinyin": "Ganzhou",
                "name": "赣州",
                "label": "赣州Ganzhou0797"
            },
            {
                "zip": "0836",
                "pinyin": "Ganzi",
                "name": "甘孜",
                "label": "甘孜Ganzi0836"
            },
            {
                "zip": "0826",
                "pinyin": "Guangan",
                "name": "广安",
                "label": "广安Guangan0826"
            },
            {
                "zip": "0839",
                "pinyin": "Guangyuan",
                "name": "广元",
                "label": "广元Guangyuan0839"
            },
            {
                "zip": "0775",
                "pinyin": "Guigang",
                "name": "贵港",
                "label": "贵港Guigang0775"
            },
            {
                "zip": "0773",
                "pinyin": "Guilin",
                "name": "桂林",
                "label": "桂林Guilin0773"
            },
            {
                "zip": "0975",
                "pinyin": "Guoluo",
                "name": "果洛",
                "label": "果洛Guoluo0975"
            },
            {
                "zip": "0954",
                "pinyin": "Guyuan",
                "name": "固原",
                "label": "固原Guyuan0954"
            },
            {
                "zip": "0797",
                "pinyin": "Ganxian",
                "name": "赣县",
                "label": "赣县Ganxian0797"
            },
            {
                "zip": "0518",
                "pinyin": "Ganyu",
                "name": "赣榆",
                "label": "赣榆Ganyu0518"
            },
            {
                "zip": "0795",
                "pinyin": "Gaoan",
                "name": "高安",
                "label": "高安Gaoan0795"
            },
            {
                "zip": "0311",
                "pinyin": "Gaocheng",
                "name": "藁城",
                "label": "藁城Gaocheng0311"
            },
            {
                "zip": "025",
                "pinyin": "Gaochun",
                "name": "高淳",
                "label": "高淳Gaochun025"
            },
            {
                "zip": "0931",
                "pinyin": "Gaolan",
                "name": "皋兰",
                "label": "皋兰Gaolan0931"
            },
            {
                "zip": "029",
                "pinyin": "Gaoling",
                "name": "高陵",
                "label": "高陵Gaoling029"
            },
            {
                "zip": "0536",
                "pinyin": "Gaomi",
                "name": "高密",
                "label": "高密Gaomi0536"
            },
            {
                "zip": "0533",
                "pinyin": "Gaoqing",
                "name": "高青",
                "label": "高青Gaoqing0533"
            },
            {
                "zip": "0635",
                "pinyin": "Gaotang",
                "name": "高唐",
                "label": "高唐Gaotang0635"
            },
            {
                "zip": "0758",
                "pinyin": "Gaoyao",
                "name": "高要",
                "label": "高要Gaoyao0758"
            },
            {
                "zip": "0311",
                "pinyin": "Gaoyi",
                "name": "高邑",
                "label": "高邑Gaoyi0311"
            },
            {
                "zip": "0514",
                "pinyin": "Gaoyou",
                "name": "高邮",
                "label": "高邮Gaoyou0514"
            },
            {
                "zip": "0668",
                "pinyin": "Gaozhou",
                "name": "高州",
                "label": "高州Gaozhou0668"
            },
            {
                "zip": "0371",
                "pinyin": "Gongyi",
                "name": "巩义",
                "label": "巩义Gongyi0371"
            },
            {
                "zip": "0794",
                "pinyin": "Guangchang",
                "name": "广昌",
                "label": "广昌Guangchang0794"
            },
            {
                "zip": "0563",
                "pinyin": "Guangde",
                "name": "广德",
                "label": "广德Guangde0563"
            },
            {
                "zip": "0793",
                "pinyin": "Guangfeng",
                "name": "广丰",
                "label": "广丰Guangfeng0793"
            },
            {
                "zip": "0758",
                "pinyin": "Guangning",
                "name": "广宁",
                "label": "广宁Guangning0758"
            },
            {
                "zip": "0546",
                "pinyin": "Guangrao",
                "name": "广饶",
                "label": "广饶Guangrao0546"
            },
            {
                "zip": "0599",
                "pinyin": "Guangze",
                "name": "光泽",
                "label": "光泽Guangze0599"
            },
            {
                "zip": "0518",
                "pinyin": "Guannan",
                "name": "灌南",
                "label": "灌南Guannan0518"
            },
            {
                "zip": "0635",
                "pinyin": "Guanxian",
                "name": "冠县",
                "label": "冠县Guanxian0635"
            },
            {
                "zip": "0518",
                "pinyin": "Guanyun",
                "name": "灌云",
                "label": "灌云Guanyun0518"
            },
            {
                "zip": "0701",
                "pinyin": "Guixi",
                "name": "贵溪",
                "label": "贵溪Guixi0701"
            },
            {
                "zip": "0593",
                "pinyin": "Gutian",
                "name": "古田",
                "label": "古田Gutian0593"
            },
            {
                "zip": "0552",
                "pinyin": "Guzhen",
                "name": "固镇",
                "label": "固镇Guzhen0552"
            }
        ]
    },
    {
        "index": "H",
        "citys": [
            {
                "zip": "0451",
                "pinyin": "Haerbin",
                "name": "哈尔滨",
                "label": "哈尔滨Haerbin0451"
            },
            {
                "zip": "0898",
                "pinyin": "Haikou",
                "name": "海口",
                "label": "海口Haikou0898"
            },
            {
                "zip": "0310",
                "pinyin": "Handan",
                "name": "邯郸",
                "label": "邯郸Handan0310"
            },
            {
                "zip": "0571",
                "pinyin": "Hangzhou",
                "name": "杭州",
                "label": "杭州Hangzhou0571"
            },
            {
                "zip": "0551",
                "pinyin": "Hefei",
                "name": "合肥",
                "label": "合肥Hefei0551"
            },
            {
                "zip": "0752",
                "pinyin": "Huizhou",
                "name": "惠州",
                "label": "惠州Huizhou0752"
            },
            {
                "zip": "0970",
                "pinyin": "Haibei",
                "name": "海北",
                "label": "海北Haibei0970"
            },
            {
                "zip": "0972",
                "pinyin": "Haidong",
                "name": "海东",
                "label": "海东Haidong0972"
            },
            {
                "zip": "0974",
                "pinyin": "Hainan",
                "name": "海南",
                "label": "海南Hainan0974"
            },
            {
                "zip": "0977",
                "pinyin": "Haixi",
                "name": "海西",
                "label": "海西Haixi0977"
            },
            {
                "zip": "0902",
                "pinyin": "Hami",
                "name": "哈密",
                "label": "哈密Hami0902"
            },
            {
                "zip": "0916",
                "pinyin": "Hanzhong",
                "name": "汉中",
                "label": "汉中Hanzhong0916"
            },
            {
                "zip": "0392",
                "pinyin": "Hebi",
                "name": "鹤壁",
                "label": "鹤壁Hebi0392"
            },
            {
                "zip": "0778",
                "pinyin": "Hechi",
                "name": "河池",
                "label": "河池Hechi0778"
            },
            {
                "zip": "0468",
                "pinyin": "Hegang",
                "name": "鹤岗",
                "label": "鹤岗Hegang0468"
            },
            {
                "zip": "0456",
                "pinyin": "Heihe",
                "name": "黑河",
                "label": "黑河Heihe0456"
            },
            {
                "zip": "0318",
                "pinyin": "Hengshui",
                "name": "衡水",
                "label": "衡水Hengshui0318"
            },
            {
                "zip": "0734",
                "pinyin": "Hengyang",
                "name": "衡阳",
                "label": "衡阳Hengyang0734"
            },
            {
                "zip": "0903",
                "pinyin": "Hetiandi",
                "name": "和田地",
                "label": "和田地Hetiandi0903"
            },
            {
                "zip": "0762",
                "pinyin": "Heyuan",
                "name": "河源",
                "label": "河源Heyuan0762"
            },
            {
                "zip": "0530",
                "pinyin": "Heze",
                "name": "菏泽",
                "label": "菏泽Heze0530"
            },
            {
                "zip": "0774",
                "pinyin": "Hezhou",
                "name": "贺州",
                "label": "贺州Hezhou0774"
            },
            {
                "zip": "0873",
                "pinyin": "Honghe",
                "name": "红河",
                "label": "红河Honghe0873"
            },
            {
                "zip": "0517",
                "pinyin": "Huaian",
                "name": "淮安",
                "label": "淮安Huaian0517"
            },
            {
                "zip": "0561",
                "pinyin": "Huaibei",
                "name": "淮北",
                "label": "淮北Huaibei0561"
            },
            {
                "zip": "0745",
                "pinyin": "Huaihua",
                "name": "怀化",
                "label": "怀化Huaihua0745"
            },
            {
                "zip": "0554",
                "pinyin": "Huainan",
                "name": "淮南",
                "label": "淮南Huainan0554"
            },
            {
                "zip": "0713",
                "pinyin": "Huanggang",
                "name": "黄冈",
                "label": "黄冈Huanggang0713"
            },
            {
                "zip": "0973",
                "pinyin": "Huangnan",
                "name": "黄南",
                "label": "黄南Huangnan0973"
            },
            {
                "zip": "0559",
                "pinyin": "Huangshan",
                "name": "黄山",
                "label": "黄山Huangshan0559"
            },
            {
                "zip": "0714",
                "pinyin": "Huangshi",
                "name": "黄石",
                "label": "黄石Huangshi0714"
            },
            {
                "zip": "0471",
                "pinyin": "Huhehaote",
                "name": "呼和浩特",
                "label": "呼和浩特Huhehaote0471"
            },
            {
                "zip": "0429",
                "pinyin": "Huludao",
                "name": "葫芦岛",
                "label": "葫芦岛Huludao0429"
            },
            {
                "zip": "0470",
                "pinyin": "Hulunbeier",
                "name": "呼伦贝尔",
                "label": "呼伦贝尔Hulunbeier0470"
            },
            {
                "zip": "0572",
                "pinyin": "Huzhou",
                "name": "湖州",
                "label": "湖州Huzhou0572"
            },
            {
                "zip": "0513",
                "pinyin": "Haian",
                "name": "海安",
                "label": "海安Haian0513"
            },
            {
                "zip": "0660",
                "pinyin": "Haifeng",
                "name": "海丰",
                "label": "海丰Haifeng0660"
            },
            {
                "zip": "0513",
                "pinyin": "Haimen",
                "name": "海门",
                "label": "海门Haimen0513"
            },
            {
                "zip": "0573",
                "pinyin": "Haining",
                "name": "海宁",
                "label": "海宁Haining0573"
            },
            {
                "zip": "0573",
                "pinyin": "Haiyan",
                "name": "海盐",
                "label": "海盐Haiyan0573"
            },
            {
                "zip": "0535",
                "pinyin": "Haiyang",
                "name": "海阳",
                "label": "海阳Haiyang0535"
            },
            {
                "zip": "0565",
                "pinyin": "Hanshan",
                "name": "含山",
                "label": "含山Hanshan0565"
            },
            {
                "zip": "023",
                "pinyin": "Hechuan",
                "name": "合川",
                "label": "合川Hechuan023"
            },
            {
                "zip": "0793",
                "pinyin": "Hengfeng",
                "name": "横峰",
                "label": "横峰Hengfeng0793"
            },
            {
                "zip": "0771",
                "pinyin": "Hengxian",
                "name": "横县",
                "label": "横县Hengxian0771"
            },
            {
                "zip": "0762",
                "pinyin": "Heping",
                "name": "和平",
                "label": "和平Heping0762"
            },
            {
                "zip": "0750",
                "pinyin": "Heshan",
                "name": "鹤山",
                "label": "鹤山Heshan0750"
            },
            {
                "zip": "0565",
                "pinyin": "Hexian",
                "name": "和县",
                "label": "和县Hexian0565"
            },
            {
                "zip": "0517",
                "pinyin": "Hongze",
                "name": "洪泽",
                "label": "洪泽Hongze0517"
            },
            {
                "zip": "0596",
                "pinyin": "Huaan",
                "name": "华安",
                "label": "华安Huaan0596"
            },
            {
                "zip": "0423",
                "pinyin": "Huadian",
                "name": "桦甸",
                "label": "桦甸Huadian0423"
            },
            {
                "zip": "0758",
                "pinyin": "Huaiji",
                "name": "怀集",
                "label": "怀集Huaiji0758"
            },
            {
                "zip": "0556",
                "pinyin": "Huaining",
                "name": "怀宁",
                "label": "怀宁Huaining0556"
            },
            {
                "zip": "0552",
                "pinyin": "Huaiyuan",
                "name": "怀远",
                "label": "怀远Huaiyuan0552"
            },
            {
                "zip": "0533",
                "pinyin": "Huantai",
                "name": "桓台",
                "label": "桓台Huantai0533"
            },
            {
                "zip": "0668",
                "pinyin": "Huazhou",
                "name": "化州",
                "label": "化州Huazhou0668"
            },
            {
                "zip": "0595",
                "pinyin": "Huian",
                "name": "惠安",
                "label": "惠安Huian0595"
            },
            {
                "zip": "0797",
                "pinyin": "Huichang",
                "name": "会昌",
                "label": "会昌Huichang0797"
            },
            {
                "zip": "0752",
                "pinyin": "Huidong",
                "name": "惠东",
                "label": "惠东Huidong0752"
            },
            {
                "zip": "0663",
                "pinyin": "Huilai",
                "name": "惠来",
                "label": "惠来Huilai0663"
            },
            {
                "zip": "0543",
                "pinyin": "Huimin",
                "name": "惠民",
                "label": "惠民Huimin0543"
            },
            {
                "zip": "0792",
                "pinyin": "Hukou",
                "name": "湖口",
                "label": "湖口Hukou0792"
            },
            {
                "zip": "0451",
                "pinyin": "Hulan",
                "name": "呼兰",
                "label": "呼兰Hulan0451"
            },
            {
                "zip": "0564",
                "pinyin": "Huoqiu",
                "name": "霍邱",
                "label": "霍邱Huoqiu0564"
            },
            {
                "zip": "0564",
                "pinyin": "Huoshan",
                "name": "霍山",
                "label": "霍山Huoshan0564"
            },
            {
                "zip": "029",
                "pinyin": "Huxian",
                "name": "户县",
                "label": "户县Huxian029"
            }
        ]
    },
    {
        "index": "J",
        "citys": [
            {
                "zip": "0391",
                "pinyin": "Jiaozuo",
                "name": "焦作",
                "label": "焦作Jiaozuo0391"
            },
            {
                "zip": "0573",
                "pinyin": "Jiaxing",
                "name": "嘉兴",
                "label": "嘉兴Jiaxing0573"
            },
            {
                "zip": "0423",
                "pinyin": "Jilin",
                "name": "吉林",
                "label": "吉林Jilin0423"
            },
            {
                "zip": "0531",
                "pinyin": "Jinan",
                "name": "济南",
                "label": "济南Jinan0531"
            },
            {
                "zip": "0454",
                "pinyin": "Jiamusi",
                "name": "佳木斯",
                "label": "佳木斯Jiamusi0454"
            },
            {
                "zip": "0750",
                "pinyin": "Jiangmen",
                "name": "江门",
                "label": "江门Jiangmen0750"
            },
            {
                "zip": "0796",
                "pinyin": "Jian",
                "name": "吉安",
                "label": "吉安Jian0796"
            },
            {
                "zip": "0937",
                "pinyin": "Jiayuguan",
                "name": "嘉峪关",
                "label": "嘉峪关Jiayuguan0937"
            },
            {
                "zip": "0663",
                "pinyin": "Jieyang",
                "name": "揭阳",
                "label": "揭阳Jieyang0663"
            },
            {
                "zip": "0935",
                "pinyin": "Jinchang",
                "name": "金昌",
                "label": "金昌Jinchang0935"
            },
            {
                "zip": "0356",
                "pinyin": "Jincheng",
                "name": "晋城",
                "label": "晋城Jincheng0356"
            },
            {
                "zip": "0798",
                "pinyin": "Jingdezhen",
                "name": "景德镇",
                "label": "景德镇Jingdezhen0798"
            },
            {
                "zip": "0724",
                "pinyin": "Jingmen",
                "name": "荆门",
                "label": "荆门Jingmen0724"
            },
            {
                "zip": "0716",
                "pinyin": "Jingzhou",
                "name": "荆州",
                "label": "荆州Jingzhou0716"
            },
            {
                "zip": "0579",
                "pinyin": "Jinhua",
                "name": "金华",
                "label": "金华Jinhua0579"
            },
            {
                "zip": "0537",
                "pinyin": "Jining",
                "name": "济宁",
                "label": "济宁Jining0537"
            },
            {
                "zip": "0354",
                "pinyin": "Jinzhong",
                "name": "晋中",
                "label": "晋中Jinzhong0354"
            },
            {
                "zip": "0416",
                "pinyin": "Jinzhou",
                "name": "锦州",
                "label": "锦州Jinzhou0416"
            },
            {
                "zip": "0792",
                "pinyin": "Jiujiang",
                "name": "九江",
                "label": "九江Jiujiang0792"
            },
            {
                "zip": "0937",
                "pinyin": "Jiuquan",
                "name": "酒泉",
                "label": "酒泉Jiuquan0937"
            },
            {
                "zip": "0467",
                "pinyin": "Jixi",
                "name": "鸡西",
                "label": "鸡西Jixi0467"
            },
            {
                "zip": "0571",
                "pinyin": "Jiande",
                "name": "建德",
                "label": "建德Jiande0571"
            },
            {
                "zip": "0514",
                "pinyin": "Jiangdu",
                "name": "江都",
                "label": "江都Jiangdu0514"
            },
            {
                "zip": "023",
                "pinyin": "Jiangjin",
                "name": "江津",
                "label": "江津Jiangjin023"
            },
            {
                "zip": "0598",
                "pinyin": "Jiangle",
                "name": "将乐",
                "label": "将乐Jiangle0598"
            },
            {
                "zip": "0570",
                "pinyin": "Jiangshan",
                "name": "江山",
                "label": "江山Jiangshan0570"
            },
            {
                "zip": "0523",
                "pinyin": "Jiangyan",
                "name": "姜堰",
                "label": "姜堰Jiangyan0523"
            },
            {
                "zip": "0510",
                "pinyin": "Jiangyin",
                "name": "江阴",
                "label": "江阴Jiangyin0510"
            },
            {
                "zip": "0515",
                "pinyin": "Jianhu",
                "name": "建湖",
                "label": "建湖Jianhu0515"
            },
            {
                "zip": "0598",
                "pinyin": "Jianning",
                "name": "建宁",
                "label": "建宁Jianning0598"
            },
            {
                "zip": "0599",
                "pinyin": "Jianou",
                "name": "建瓯",
                "label": "建瓯Jianou0599"
            },
            {
                "zip": "0599",
                "pinyin": "Jianyang",
                "name": "建阳",
                "label": "建阳Jianyang0599"
            },
            {
                "zip": "0796",
                "pinyin": "Jian",
                "name": "吉安",
                "label": "吉安Jian0796"
            },
            {
                "zip": "0423",
                "pinyin": "Jiaohe",
                "name": "蛟河",
                "label": "蛟河Jiaohe0423"
            },
            {
                "zip": "0753",
                "pinyin": "Jiaoling",
                "name": "蕉岭",
                "label": "蕉岭Jiaoling0753"
            },
            {
                "zip": "0532",
                "pinyin": "Jiaonan",
                "name": "胶南",
                "label": "胶南Jiaonan0532"
            },
            {
                "zip": "0532",
                "pinyin": "Jiaozhou",
                "name": "胶州",
                "label": "胶州Jiaozhou0532"
            },
            {
                "zip": "0573",
                "pinyin": "Jiashan",
                "name": "嘉善",
                "label": "嘉善Jiashan0573"
            },
            {
                "zip": "0537",
                "pinyin": "Jiaxiang",
                "name": "嘉祥",
                "label": "嘉祥Jiaxiang0537"
            },
            {
                "zip": "0663",
                "pinyin": "Jiedong",
                "name": "揭东",
                "label": "揭东Jiedong0663"
            },
            {
                "zip": "0558",
                "pinyin": "Jieshou",
                "name": "界首",
                "label": "界首Jieshou0558"
            },
            {
                "zip": "0663",
                "pinyin": "Jiexi",
                "name": "揭西",
                "label": "揭西Jiexi0663"
            },
            {
                "zip": "0532",
                "pinyin": "Jimo",
                "name": "即墨",
                "label": "即墨Jimo0532"
            },
            {
                "zip": "0795",
                "pinyin": "Jingan",
                "name": "靖安",
                "label": "靖安Jingan0795"
            },
            {
                "zip": "0563",
                "pinyin": "Jingde",
                "name": "旌德",
                "label": "旌德Jingde0563"
            },
            {
                "zip": "0796",
                "pinyin": "Jinggangshan",
                "name": "井冈山",
                "label": "井冈山Jinggangshan0796"
            },
            {
                "zip": "0523",
                "pinyin": "Jingjiang",
                "name": "靖江",
                "label": "靖江Jingjiang0523"
            },
            {
                "zip": "0578",
                "pinyin": "Jingning",
                "name": "景宁",
                "label": "景宁Jingning0578"
            },
            {
                "zip": "0563",
                "pinyin": "Jingxian",
                "name": "泾县",
                "label": "泾县Jingxian0563"
            },
            {
                "zip": "0311",
                "pinyin": "Jingxing",
                "name": "井陉",
                "label": "井陉Jingxing0311"
            },
            {
                "zip": "0517",
                "pinyin": "Jinhu",
                "name": "金湖",
                "label": "金湖Jinhu0517"
            },
            {
                "zip": "0595",
                "pinyin": "Jinjiang",
                "name": "晋江",
                "label": "晋江Jinjiang0595"
            },
            {
                "zip": "0595",
                "pinyin": "Jinmen",
                "name": "金门",
                "label": "金门Jinmen0595"
            },
            {
                "zip": "0871",
                "pinyin": "Jinning",
                "name": "晋宁",
                "label": "晋宁Jinning0871"
            },
            {
                "zip": "0519",
                "pinyin": "Jintan",
                "name": "金坛",
                "label": "金坛Jintan0519"
            },
            {
                "zip": "028",
                "pinyin": "Jintang",
                "name": "金堂",
                "label": "金堂Jintang028"
            },
            {
                "zip": "0791",
                "pinyin": "Jinxian",
                "name": "进贤",
                "label": "进贤Jinxian0791"
            },
            {
                "zip": "0794",
                "pinyin": "Jinxi",
                "name": "金溪",
                "label": "金溪Jinxi0794"
            },
            {
                "zip": "0537",
                "pinyin": "Jinxiang",
                "name": "金乡",
                "label": "金乡Jinxiang0537"
            },
            {
                "zip": "0578",
                "pinyin": "Jinyun",
                "name": "缙云",
                "label": "缙云Jinyun0578"
            },
            {
                "zip": "0564",
                "pinyin": "Jinzhai",
                "name": "金寨",
                "label": "金寨Jinzhai0564"
            },
            {
                "zip": "0311",
                "pinyin": "Jinzhou",
                "name": "晋州",
                "label": "晋州Jinzhou0311"
            },
            {
                "zip": "0796",
                "pinyin": "Jishui",
                "name": "吉水",
                "label": "吉水Jishui0796"
            },
            {
                "zip": "0792",
                "pinyin": "Jiujiang",
                "name": "九江",
                "label": "九江Jiujiang0792"
            },
            {
                "zip": "0431",
                "pinyin": "Jiutai",
                "name": "九台",
                "label": "九台Jiutai0431"
            },
            {
                "zip": "0563",
                "pinyin": "Jixi",
                "name": "绩溪",
                "label": "绩溪Jixi0563"
            },
            {
                "zip": "0531",
                "pinyin": "Jiyang",
                "name": "济阳",
                "label": "济阳Jiyang0531"
            },
            {
                "zip": "0391",
                "pinyin": "Jiyuan",
                "name": "济源",
                "label": "济源Jiyuan0391"
            },
            {
                "zip": "0530",
                "pinyin": "Juancheng",
                "name": "鄄城",
                "label": "鄄城Juancheng0530"
            },
            {
                "zip": "0539",
                "pinyin": "Junan",
                "name": "莒南",
                "label": "莒南Junan0539"
            },
            {
                "zip": "0511",
                "pinyin": "Jurong",
                "name": "句容",
                "label": "句容Jurong0511"
            },
            {
                "zip": "0633",
                "pinyin": "Juxian",
                "name": "莒县",
                "label": "莒县Juxian0633"
            },
            {
                "zip": "0530",
                "pinyin": "Juye",
                "name": "巨野",
                "label": "巨野Juye0530"
            }
        ]
    },
    {
        "index": "K",
        "citys": [
            {
                "zip": "0871",
                "pinyin": "Kunming",
                "name": "昆明",
                "label": "昆明Kunming0871"
            },
            {
                "zip": "0378",
                "pinyin": "Kaifeng",
                "name": "开封",
                "label": "开封Kaifeng0378"
            },
            {
                "zip": "0998",
                "pinyin": "Kashidi",
                "name": "喀什地",
                "label": "喀什地Kashidi0998"
            },
            {
                "zip": "0990",
                "pinyin": "Kelamayi",
                "name": "克拉玛依",
                "label": "克拉玛依Kelamayi0990"
            },
            {
                "zip": "0908",
                "pinyin": "Kezile",
                "name": "克孜勒",
                "label": "克孜勒Kezile0908"
            },
            {
                "zip": "0570",
                "pinyin": "Kaihua",
                "name": "开化",
                "label": "开化Kaihua0570"
            },
            {
                "zip": "0750",
                "pinyin": "Kaiping",
                "name": "开平",
                "label": "开平Kaiping0750"
            },
            {
                "zip": "023",
                "pinyin": "Kaixian",
                "name": "开县",
                "label": "开县Kaixian023"
            },
            {
                "zip": "0851",
                "pinyin": "Kaiyang",
                "name": "开阳",
                "label": "开阳Kaiyang0851"
            },
            {
                "zip": "024",
                "pinyin": "Kangping",
                "name": "康平",
                "label": "康平Kangping024"
            },
            {
                "zip": "0546",
                "pinyin": "Kenli",
                "name": "垦利",
                "label": "垦利Kenli0546"
            },
            {
                "zip": "0512",
                "pinyin": "Kunshan",
                "name": "昆山",
                "label": "昆山Kunshan0512"
            }
        ]
    },
    {
        "index": "L",
        "citys": [
            {
                "zip": "0931",
                "pinyin": "Lanzhou",
                "name": "兰州",
                "label": "兰州Lanzhou0931"
            },
            {
                "zip": "0772",
                "pinyin": "Liuzhou",
                "name": "柳州",
                "label": "柳州Liuzhou0772"
            },
            {
                "zip": "0379",
                "pinyin": "Luoyang",
                "name": "洛阳",
                "label": "洛阳Luoyang0379"
            },
            {
                "zip": "0772",
                "pinyin": "Laibin",
                "name": "来宾",
                "label": "来宾Laibin0772"
            },
            {
                "zip": "0634",
                "pinyin": "Laiwu",
                "name": "莱芜",
                "label": "莱芜Laiwu0634"
            },
            {
                "zip": "0316",
                "pinyin": "Langfang",
                "name": "廊坊",
                "label": "廊坊Langfang0316"
            },
            {
                "zip": "0891",
                "pinyin": "Lasa",
                "name": "拉萨",
                "label": "拉萨Lasa0891"
            },
            {
                "zip": "0833",
                "pinyin": "Leshan",
                "name": "乐山",
                "label": "乐山Leshan0833"
            },
            {
                "zip": "0834",
                "pinyin": "Liangshan",
                "name": "凉山",
                "label": "凉山Liangshan0834"
            },
            {
                "zip": "0518",
                "pinyin": "Lianyungang",
                "name": "连云港",
                "label": "连云港Lianyungang0518"
            },
            {
                "zip": "0635",
                "pinyin": "Liaocheng",
                "name": "聊城",
                "label": "聊城Liaocheng0635"
            },
            {
                "zip": "0419",
                "pinyin": "Liaoyang",
                "name": "辽阳",
                "label": "辽阳Liaoyang0419"
            },
            {
                "zip": "0437",
                "pinyin": "Liaoyuan",
                "name": "辽源",
                "label": "辽源Liaoyuan0437"
            },
            {
                "zip": "0888",
                "pinyin": "Lijiang",
                "name": "丽江",
                "label": "丽江Lijiang0888"
            },
            {
                "zip": "0883",
                "pinyin": "Lincang",
                "name": "临沧",
                "label": "临沧Lincang0883"
            },
            {
                "zip": "0357",
                "pinyin": "Linfen",
                "name": "临汾",
                "label": "临汾Linfen0357"
            },
            {
                "zip": "0930",
                "pinyin": "Linxia",
                "name": "临夏",
                "label": "临夏Linxia0930"
            },
            {
                "zip": "0539",
                "pinyin": "Linyi",
                "name": "临沂",
                "label": "临沂Linyi0539"
            },
            {
                "zip": "0894",
                "pinyin": "Linzhi",
                "name": "林芝",
                "label": "林芝Linzhi0894"
            },
            {
                "zip": "0578",
                "pinyin": "Lishui",
                "name": "丽水",
                "label": "丽水Lishui0578"
            },
            {
                "zip": "0564",
                "pinyin": "Liuan",
                "name": "六安",
                "label": "六安Liuan0564"
            },
            {
                "zip": "0858",
                "pinyin": "Liupanshui",
                "name": "六盘水",
                "label": "六盘水Liupanshui0858"
            },
            {
                "zip": "0939",
                "pinyin": "Longnan",
                "name": "陇南",
                "label": "陇南Longnan0939"
            },
            {
                "zip": "0597",
                "pinyin": "Longyan",
                "name": "龙岩",
                "label": "龙岩Longyan0597"
            },
            {
                "zip": "0738",
                "pinyin": "Loudi",
                "name": "娄底",
                "label": "娄底Loudi0738"
            },
            {
                "zip": "0395",
                "pinyin": "Luohe",
                "name": "漯河",
                "label": "漯河Luohe0395"
            },
            {
                "zip": "0830",
                "pinyin": "Luzhou",
                "name": "泸州",
                "label": "泸州Luzhou0830"
            },
            {
                "zip": "0358",
                "pinyin": "Lvliang",
                "name": "吕梁",
                "label": "吕梁Lvliang0358"
            },
            {
                "zip": "0550",
                "pinyin": "Laian",
                "name": "来安",
                "label": "来安Laian0550"
            },
            {
                "zip": "0532",
                "pinyin": "Laixi",
                "name": "莱西",
                "label": "莱西Laixi0532"
            },
            {
                "zip": "0535",
                "pinyin": "Laiyang",
                "name": "莱阳",
                "label": "莱阳Laiyang0535"
            },
            {
                "zip": "0535",
                "pinyin": "Laizhou",
                "name": "莱州",
                "label": "莱州Laizhou0535"
            },
            {
                "zip": "0563",
                "pinyin": "Langxi",
                "name": "郎溪",
                "label": "郎溪Langxi0563"
            },
            {
                "zip": "029",
                "pinyin": "Lantian",
                "name": "蓝田",
                "label": "蓝田Lantian029"
            },
            {
                "zip": "0579",
                "pinyin": "Lanxi",
                "name": "兰溪",
                "label": "兰溪Lanxi0579"
            },
            {
                "zip": "0794",
                "pinyin": "Lean",
                "name": "乐安",
                "label": "乐安Lean0794"
            },
            {
                "zip": "0751",
                "pinyin": "Lechang",
                "name": "乐昌",
                "label": "乐昌Lechang0751"
            },
            {
                "zip": "0759",
                "pinyin": "Leizhou",
                "name": "雷州",
                "label": "雷州Leizhou0759"
            },
            {
                "zip": "0534",
                "pinyin": "Leling",
                "name": "乐陵",
                "label": "乐陵Leling0534"
            },
            {
                "zip": "0798",
                "pinyin": "Leping",
                "name": "乐平",
                "label": "乐平Leping0798"
            },
            {
                "zip": "0577",
                "pinyin": "Leqing",
                "name": "乐清",
                "label": "乐清Leqing0577"
            },
            {
                "zip": "0315",
                "pinyin": "Leting",
                "name": "乐亭",
                "label": "乐亭Leting0315"
            },
            {
                "zip": "0597",
                "pinyin": "Liancheng",
                "name": "连城",
                "label": "连城Liancheng0597"
            },
            {
                "zip": "023",
                "pinyin": "Liangping",
                "name": "梁平",
                "label": "梁平Liangping023"
            },
            {
                "zip": "0537",
                "pinyin": "Liangshan",
                "name": "梁山",
                "label": "梁山Liangshan0537"
            },
            {
                "zip": "0799",
                "pinyin": "Lianhua",
                "name": "莲花",
                "label": "莲花Lianhua0799"
            },
            {
                "zip": "0591",
                "pinyin": "Lianjiang",
                "name": "连江",
                "label": "连江Lianjiang0591"
            },
            {
                "zip": "0759",
                "pinyin": "Lianjiang",
                "name": "廉江",
                "label": "廉江Lianjiang0759"
            },
            {
                "zip": "0763",
                "pinyin": "Liannan",
                "name": "连南",
                "label": "连南Liannan0763"
            },
            {
                "zip": "0762",
                "pinyin": "Lianping",
                "name": "连平",
                "label": "连平Lianping0762"
            },
            {
                "zip": "0763",
                "pinyin": "Lianshan",
                "name": "连山",
                "label": "连山Lianshan0763"
            },
            {
                "zip": "0517",
                "pinyin": "Lianshui",
                "name": "涟水",
                "label": "涟水Lianshui0517"
            },
            {
                "zip": "0763",
                "pinyin": "Lianzhou",
                "name": "连州",
                "label": "连州Lianzhou0763"
            },
            {
                "zip": "024",
                "pinyin": "Liaozhong",
                "name": "辽中",
                "label": "辽中Liaozhong024"
            },
            {
                "zip": "0794",
                "pinyin": "Lichuan",
                "name": "黎川",
                "label": "黎川Lichuan0794"
            },
            {
                "zip": "0546",
                "pinyin": "Lijin",
                "name": "利津",
                "label": "利津Lijin0546"
            },
            {
                "zip": "0571",
                "pinyin": "Linan",
                "name": "临安",
                "label": "临安Linan0571"
            },
            {
                "zip": "0557",
                "pinyin": "Lingbi",
                "name": "灵璧",
                "label": "灵璧Lingbi0557"
            },
            {
                "zip": "0311",
                "pinyin": "Lingshou",
                "name": "灵寿",
                "label": "灵寿Lingshou0311"
            },
            {
                "zip": "0534",
                "pinyin": "Lingxian",
                "name": "陵县",
                "label": "陵县Lingxian0534"
            },
            {
                "zip": "0576",
                "pinyin": "Linhai",
                "name": "临海",
                "label": "临海Linhai0576"
            },
            {
                "zip": "0635",
                "pinyin": "Linqing",
                "name": "临清",
                "label": "临清Linqing0635"
            },
            {
                "zip": "0558",
                "pinyin": "Linquan",
                "name": "临泉",
                "label": "临泉Linquan0558"
            },
            {
                "zip": "0536",
                "pinyin": "Linqu",
                "name": "临朐",
                "label": "临朐Linqu0536"
            },
            {
                "zip": "0539",
                "pinyin": "Linshu",
                "name": "临沭",
                "label": "临沭Linshu0539"
            },
            {
                "zip": "0534",
                "pinyin": "Linyi",
                "name": "临邑",
                "label": "临邑Linyi0534"
            },
            {
                "zip": "025",
                "pinyin": "Lishui",
                "name": "溧水",
                "label": "溧水Lishui025"
            },
            {
                "zip": "0772",
                "pinyin": "Liucheng",
                "name": "柳城",
                "label": "柳城Liucheng0772"
            },
            {
                "zip": "0772",
                "pinyin": "Liujiang",
                "name": "柳江",
                "label": "柳江Liujiang0772"
            },
            {
                "zip": "0731",
                "pinyin": "Liuyang",
                "name": "浏阳",
                "label": "浏阳Liuyang0731"
            },
            {
                "zip": "0558",
                "pinyin": "Lixin",
                "name": "利辛",
                "label": "利辛Lixin0558"
            },
            {
                "zip": "0519",
                "pinyin": "Liyang",
                "name": "溧阳",
                "label": "溧阳Liyang0519"
            },
            {
                "zip": "0771",
                "pinyin": "Longan",
                "name": "隆安",
                "label": "隆安Longan0771"
            },
            {
                "zip": "0762",
                "pinyin": "Longchuan",
                "name": "龙川",
                "label": "龙川Longchuan0762"
            },
            {
                "zip": "0596",
                "pinyin": "Longhai",
                "name": "龙海",
                "label": "龙海Longhai0596"
            },
            {
                "zip": "0535",
                "pinyin": "Longkou",
                "name": "龙口",
                "label": "龙口Longkou0535"
            },
            {
                "zip": "0752",
                "pinyin": "Longmen",
                "name": "龙门",
                "label": "龙门Longmen0752"
            },
            {
                "zip": "0797",
                "pinyin": "Longnan",
                "name": "龙南",
                "label": "龙南Longnan0797"
            },
            {
                "zip": "0578",
                "pinyin": "Longquan",
                "name": "龙泉",
                "label": "龙泉Longquan0578"
            },
            {
                "zip": "0570",
                "pinyin": "Longyou",
                "name": "龙游",
                "label": "龙游Longyou0570"
            },
            {
                "zip": "0311",
                "pinyin": "Luancheng",
                "name": "栾城",
                "label": "栾城Luancheng0311"
            },
            {
                "zip": "0379",
                "pinyin": "Luanchuan",
                "name": "栾川",
                "label": "栾川Luanchuan0379"
            },
            {
                "zip": "0315",
                "pinyin": "Luannan",
                "name": "滦南",
                "label": "滦南Luannan0315"
            },
            {
                "zip": "0315",
                "pinyin": "Luanxian",
                "name": "滦县",
                "label": "滦县Luanxian0315"
            },
            {
                "zip": "0660",
                "pinyin": "Lufeng",
                "name": "陆丰",
                "label": "陆丰Lufeng0660"
            },
            {
                "zip": "0660",
                "pinyin": "Luhe",
                "name": "陆河",
                "label": "陆河Luhe0660"
            },
            {
                "zip": "0565",
                "pinyin": "Lujiang",
                "name": "庐江",
                "label": "庐江Lujiang0565"
            },
            {
                "zip": "0766",
                "pinyin": "Luoding",
                "name": "罗定",
                "label": "罗定Luoding0766"
            },
            {
                "zip": "0379",
                "pinyin": "Luoning",
                "name": "洛宁",
                "label": "洛宁Luoning0379"
            },
            {
                "zip": "0591",
                "pinyin": "Luoyuan",
                "name": "罗源",
                "label": "罗源Luoyuan0591"
            },
            {
                "zip": "0311",
                "pinyin": "Luquan",
                "name": "鹿泉",
                "label": "鹿泉Luquan0311"
            },
            {
                "zip": "0871",
                "pinyin": "Luquan",
                "name": "禄劝",
                "label": "禄劝Luquan0871"
            },
            {
                "zip": "0799",
                "pinyin": "Luxi",
                "name": "芦溪",
                "label": "芦溪Luxi0799"
            },
            {
                "zip": "0772",
                "pinyin": "Luzhai",
                "name": "鹿寨",
                "label": "鹿寨Luzhai0772"
            }
        ]
    },
    {
        "index": "M",
        "citys": [
            {
                "zip": "0555",
                "pinyin": "Maanshan",
                "name": "马鞍山",
                "label": "马鞍山Maanshan0555"
            },
            {
                "zip": "0668",
                "pinyin": "Maoming",
                "name": "茂名",
                "label": "茂名Maoming0668"
            },
            {
                "zip": "028",
                "pinyin": "Meishan",
                "name": "眉山",
                "label": "眉山Meishan028"
            },
            {
                "zip": "0753",
                "pinyin": "Meizhou",
                "name": "梅州",
                "label": "梅州Meizhou0753"
            },
            {
                "zip": "0816",
                "pinyin": "Mianyang",
                "name": "绵阳",
                "label": "绵阳Mianyang0816"
            },
            {
                "zip": "0453",
                "pinyin": "Mudanjiang",
                "name": "牡丹江",
                "label": "牡丹江Mudanjiang0453"
            },
            {
                "zip": "0771",
                "pinyin": "Mashan",
                "name": "马山",
                "label": "马山Mashan0771"
            },
            {
                "zip": "0753",
                "pinyin": "Meixian",
                "name": "梅县",
                "label": "梅县Meixian0753"
            },
            {
                "zip": "0558",
                "pinyin": "Mengcheng",
                "name": "蒙城",
                "label": "蒙城Mengcheng0558"
            },
            {
                "zip": "0379",
                "pinyin": "Mengjin",
                "name": "孟津",
                "label": "孟津Mengjin0379"
            },
            {
                "zip": "0539",
                "pinyin": "Mengyin",
                "name": "蒙阴",
                "label": "蒙阴Mengyin0539"
            },
            {
                "zip": "0391",
                "pinyin": "Mengzhou",
                "name": "孟州",
                "label": "孟州Mengzhou0391"
            },
            {
                "zip": "0550",
                "pinyin": "Mingguang",
                "name": "明光",
                "label": "明光Mingguang0550"
            },
            {
                "zip": "0598",
                "pinyin": "Mingxi",
                "name": "明溪",
                "label": "明溪Mingxi0598"
            },
            {
                "zip": "0591",
                "pinyin": "Minhou",
                "name": "闽侯",
                "label": "闽侯Minhou0591"
            },
            {
                "zip": "0591",
                "pinyin": "Minqing",
                "name": "闽清",
                "label": "闽清Minqing0591"
            },
            {
                "zip": "0451",
                "pinyin": "Mulan",
                "name": "木兰",
                "label": "木兰Mulan0451"
            }
        ]
    },
    {
        "index": "N",
        "citys": [
            {
                "zip": "0791",
                "pinyin": "Nanchang",
                "name": "南昌",
                "label": "南昌Nanchang0791"
            },
            {
                "zip": "025",
                "pinyin": "Nanjing",
                "name": "南京",
                "label": "南京Nanjing025"
            },
            {
                "zip": "0771",
                "pinyin": "Nanning",
                "name": "南宁",
                "label": "南宁Nanning0771"
            },
            {
                "zip": "0513",
                "pinyin": "Nantong",
                "name": "南通",
                "label": "南通Nantong0513"
            },
            {
                "zip": "0574",
                "pinyin": "Ningbo",
                "name": "宁波",
                "label": "宁波Ningbo0574"
            },
            {
                "zip": "0817",
                "pinyin": "Nanchong",
                "name": "南充",
                "label": "南充Nanchong0817"
            },
            {
                "zip": "0599",
                "pinyin": "Nanping",
                "name": "南平",
                "label": "南平Nanping0599"
            },
            {
                "zip": "0377",
                "pinyin": "Nanyang",
                "name": "南阳",
                "label": "南阳Nanyang0377"
            },
            {
                "zip": "0896",
                "pinyin": "Naqu",
                "name": "那曲",
                "label": "那曲Naqu0896"
            },
            {
                "zip": "0832",
                "pinyin": "Neijiang",
                "name": "内江",
                "label": "内江Neijiang0832"
            },
            {
                "zip": "0593",
                "pinyin": "Ningde",
                "name": "宁德",
                "label": "宁德Ningde0593"
            },
            {
                "zip": "0886",
                "pinyin": "Nujiang",
                "name": "怒江",
                "label": "怒江Nujiang0886"
            },
            {
                "zip": "0595",
                "pinyin": "Nanan",
                "name": "南安",
                "label": "南安Nanan0595"
            },
            {
                "zip": "0754",
                "pinyin": "Nanao",
                "name": "南澳",
                "label": "南澳Nanao0754"
            },
            {
                "zip": "0794",
                "pinyin": "Nancheng",
                "name": "南城",
                "label": "南城Nancheng0794"
            },
            {
                "zip": "023",
                "pinyin": "Nanchuan",
                "name": "南川",
                "label": "南川Nanchuan023"
            },
            {
                "zip": "0794",
                "pinyin": "Nanfeng",
                "name": "南丰",
                "label": "南丰Nanfeng0794"
            },
            {
                "zip": "0596",
                "pinyin": "Nanjing",
                "name": "南靖",
                "label": "南靖Nanjing0596"
            },
            {
                "zip": "0797",
                "pinyin": "Nankang",
                "name": "南康",
                "label": "南康Nankang0797"
            },
            {
                "zip": "0553",
                "pinyin": "Nanling",
                "name": "南陵",
                "label": "南陵Nanling0553"
            },
            {
                "zip": "0751",
                "pinyin": "Nanxiong",
                "name": "南雄",
                "label": "南雄Nanxiong0751"
            },
            {
                "zip": "0797",
                "pinyin": "Ningdu",
                "name": "宁都",
                "label": "宁都Ningdu0797"
            },
            {
                "zip": "0563",
                "pinyin": "Ningguo",
                "name": "宁国",
                "label": "宁国Ningguo0563"
            },
            {
                "zip": "0574",
                "pinyin": "Ninghai",
                "name": "宁海",
                "label": "宁海Ninghai0574"
            },
            {
                "zip": "0598",
                "pinyin": "Ninghua",
                "name": "宁化",
                "label": "宁化Ninghua0598"
            },
            {
                "zip": "0534",
                "pinyin": "Ningjin",
                "name": "宁津",
                "label": "宁津Ningjin0534"
            },
            {
                "zip": "0731",
                "pinyin": "Ningxiang",
                "name": "宁乡",
                "label": "宁乡Ningxiang0731"
            },
            {
                "zip": "0538",
                "pinyin": "Ningyang",
                "name": "宁阳",
                "label": "宁阳Ningyang0538"
            },
            {
                "zip": "0431",
                "pinyin": "Nongan",
                "name": "农安",
                "label": "农安Nongan0431"
            }
        ]
    },
    {
        "index": "P",
        "citys": [
            {
                "zip": "0427",
                "pinyin": "Panjin",
                "name": "盘锦",
                "label": "盘锦Panjin0427"
            },
            {
                "zip": "0812",
                "pinyin": "Panzhihua",
                "name": "攀枝花",
                "label": "攀枝花Panzhihua0812"
            },
            {
                "zip": "0375",
                "pinyin": "Pingdingshan",
                "name": "平顶山",
                "label": "平顶山Pingdingshan0375"
            },
            {
                "zip": "0933",
                "pinyin": "Pingliang",
                "name": "平凉",
                "label": "平凉Pingliang0933"
            },
            {
                "zip": "0799",
                "pinyin": "Pingxiang",
                "name": "萍乡",
                "label": "萍乡Pingxiang0799"
            },
            {
                "zip": "0879",
                "pinyin": "Puer",
                "name": "普洱",
                "label": "普洱Puer0879"
            },
            {
                "zip": "0594",
                "pinyin": "Putian",
                "name": "莆田",
                "label": "莆田Putian0594"
            },
            {
                "zip": "0393",
                "pinyin": "Puyang",
                "name": "濮阳",
                "label": "濮阳Puyang0393"
            },
            {
                "zip": "0579",
                "pinyin": "Panan",
                "name": "磐安",
                "label": "磐安Panan0579"
            },
            {
                "zip": "0423",
                "pinyin": "Panshi",
                "name": "磐石",
                "label": "磐石Panshi0423"
            },
            {
                "zip": "0516",
                "pinyin": "Peixian",
                "name": "沛县",
                "label": "沛县Peixian0516"
            },
            {
                "zip": "0535",
                "pinyin": "Penglai",
                "name": "蓬莱",
                "label": "蓬莱Penglai0535"
            },
            {
                "zip": "023",
                "pinyin": "Pengshui",
                "name": "彭水",
                "label": "彭水Pengshui023"
            },
            {
                "zip": "0792",
                "pinyin": "Pengze",
                "name": "彭泽",
                "label": "彭泽Pengze0792"
            },
            {
                "zip": "028",
                "pinyin": "Pengzhou",
                "name": "彭州",
                "label": "彭州Pengzhou028"
            },
            {
                "zip": "0532",
                "pinyin": "Pingdu",
                "name": "平度",
                "label": "平度Pingdu0532"
            },
            {
                "zip": "0596",
                "pinyin": "Pinghe",
                "name": "平和",
                "label": "平和Pinghe0596"
            },
            {
                "zip": "0573",
                "pinyin": "Pinghu",
                "name": "平湖",
                "label": "平湖Pinghu0573"
            },
            {
                "zip": "0593",
                "pinyin": "Pingnan",
                "name": "屏南",
                "label": "屏南Pingnan0593"
            },
            {
                "zip": "0311",
                "pinyin": "Pingshan",
                "name": "平山",
                "label": "平山Pingshan0311"
            },
            {
                "zip": "0591",
                "pinyin": "Pingtan",
                "name": "平潭",
                "label": "平潭Pingtan0591"
            },
            {
                "zip": "0577",
                "pinyin": "Pingyang",
                "name": "平阳",
                "label": "平阳Pingyang0577"
            },
            {
                "zip": "0531",
                "pinyin": "Pingyin",
                "name": "平阴",
                "label": "平阴Pingyin0531"
            },
            {
                "zip": "0539",
                "pinyin": "Pingyi",
                "name": "平邑",
                "label": "平邑Pingyi0539"
            },
            {
                "zip": "0534",
                "pinyin": "Pingyuan",
                "name": "平原",
                "label": "平原Pingyuan0534"
            },
            {
                "zip": "0753",
                "pinyin": "Pingyuan",
                "name": "平远",
                "label": "平远Pingyuan0753"
            },
            {
                "zip": "028",
                "pinyin": "Pixian",
                "name": "郫县",
                "label": "郫县Pixian028"
            },
            {
                "zip": "0516",
                "pinyin": "Pizhou",
                "name": "邳州",
                "label": "邳州Pizhou0516"
            },
            {
                "zip": "0793",
                "pinyin": "Poyang",
                "name": "鄱阳",
                "label": "鄱阳Poyang0793"
            },
            {
                "zip": "0599",
                "pinyin": "Pucheng",
                "name": "浦城",
                "label": "浦城Pucheng0599"
            },
            {
                "zip": "0579",
                "pinyin": "Pujiang",
                "name": "浦江",
                "label": "浦江Pujiang0579"
            },
            {
                "zip": "028",
                "pinyin": "Pujiang",
                "name": "蒲江",
                "label": "蒲江Pujiang028"
            },
            {
                "zip": "0411",
                "pinyin": "Pulandian",
                "name": "普兰店",
                "label": "普兰店Pulandian0411"
            },
            {
                "zip": "0663",
                "pinyin": "Puning",
                "name": "普宁",
                "label": "普宁Puning0663"
            }
        ]
    },
    {
        "index": "Q",
        "citys": [
            {
                "zip": "0532",
                "pinyin": "Qingdao",
                "name": "青岛",
                "label": "青岛Qingdao0532"
            },
            {
                "zip": "0595",
                "pinyin": "Quanzhou",
                "name": "泉州",
                "label": "泉州Quanzhou0595"
            },
            {
                "zip": "0855",
                "pinyin": "Qiandong",
                "name": "黔东",
                "label": "黔东Qiandong0855"
            },
            {
                "zip": "0854",
                "pinyin": "Qiannan",
                "name": "黔南",
                "label": "黔南Qiannan0854"
            },
            {
                "zip": "0859",
                "pinyin": "Qianxinan",
                "name": "黔西南",
                "label": "黔西南Qianxinan0859"
            },
            {
                "zip": "0934",
                "pinyin": "Qingyang",
                "name": "庆阳",
                "label": "庆阳Qingyang0934"
            },
            {
                "zip": "0763",
                "pinyin": "Qingyuan",
                "name": "清远",
                "label": "清远Qingyuan0763"
            },
            {
                "zip": "0335",
                "pinyin": "Qinhuangdao",
                "name": "秦皇岛",
                "label": "秦皇岛Qinhuangdao0335"
            },
            {
                "zip": "0777",
                "pinyin": "Qinzhou",
                "name": "钦州",
                "label": "钦州Qinzhou0777"
            },
            {
                "zip": "0452",
                "pinyin": "Qiqihaer",
                "name": "齐齐哈尔",
                "label": "齐齐哈尔Qiqihaer0452"
            },
            {
                "zip": "0464",
                "pinyin": "Qitaihe",
                "name": "七台河",
                "label": "七台河Qitaihe0464"
            },
            {
                "zip": "0874",
                "pinyin": "Qujing",
                "name": "曲靖",
                "label": "曲靖Qujing0874"
            },
            {
                "zip": "0570",
                "pinyin": "Quzhou",
                "name": "衢州",
                "label": "衢州Quzhou0570"
            },
            {
                "zip": "0315",
                "pinyin": "Qianan",
                "name": "迁安",
                "label": "迁安Qianan0315"
            },
            {
                "zip": "0556",
                "pinyin": "Qianshan",
                "name": "潜山",
                "label": "潜山Qianshan0556"
            },
            {
                "zip": "0793",
                "pinyin": "Qianshan",
                "name": "铅山",
                "label": "铅山Qianshan0793"
            },
            {
                "zip": "0315",
                "pinyin": "Qianxi",
                "name": "迁西",
                "label": "迁西Qianxi0315"
            },
            {
                "zip": "0513",
                "pinyin": "Qidong",
                "name": "启东",
                "label": "启东Qidong0513"
            },
            {
                "zip": "0534",
                "pinyin": "Qihe",
                "name": "齐河",
                "label": "齐河Qihe0534"
            },
            {
                "zip": "023",
                "pinyin": "Qijiang",
                "name": "綦江",
                "label": "綦江Qijiang023"
            },
            {
                "zip": "0559",
                "pinyin": "Qimen",
                "name": "祁门",
                "label": "祁门Qimen0559"
            },
            {
                "zip": "0598",
                "pinyin": "Qingliu",
                "name": "清流",
                "label": "清流Qingliu0598"
            },
            {
                "zip": "0578",
                "pinyin": "Qingtian",
                "name": "青田",
                "label": "青田Qingtian0578"
            },
            {
                "zip": "0763",
                "pinyin": "Qingxin",
                "name": "清新",
                "label": "清新Qingxin0763"
            },
            {
                "zip": "0566",
                "pinyin": "Qingyang",
                "name": "青阳",
                "label": "青阳Qingyang0566"
            },
            {
                "zip": "0578",
                "pinyin": "Qingyuan",
                "name": "庆元",
                "label": "庆元Qingyuan0578"
            },
            {
                "zip": "0534",
                "pinyin": "Qingyun",
                "name": "庆云",
                "label": "庆云Qingyun0534"
            },
            {
                "zip": "0851",
                "pinyin": "Qingzhen",
                "name": "清镇",
                "label": "清镇Qingzhen0851"
            },
            {
                "zip": "0536",
                "pinyin": "Qingzhou",
                "name": "青州",
                "label": "青州Qingzhou0536"
            },
            {
                "zip": "0391",
                "pinyin": "Qinyang",
                "name": "沁阳",
                "label": "沁阳Qinyang0391"
            },
            {
                "zip": "028",
                "pinyin": "Qionglai",
                "name": "邛崃",
                "label": "邛崃Qionglai028"
            },
            {
                "zip": "0535",
                "pinyin": "Qixia",
                "name": "栖霞",
                "label": "栖霞Qixia0535"
            },
            {
                "zip": "0550",
                "pinyin": "Quanjiao",
                "name": "全椒",
                "label": "全椒Quanjiao0550"
            },
            {
                "zip": "0797",
                "pinyin": "Quannan",
                "name": "全南",
                "label": "全南Quannan0797"
            },
            {
                "zip": "0537",
                "pinyin": "Qufu",
                "name": "曲阜",
                "label": "曲阜Qufu0537"
            },
            {
                "zip": "0751",
                "pinyin": "Qujiang",
                "name": "曲江",
                "label": "曲江Qujiang0751"
            }
        ]
    },
    {
        "index": "R",
        "citys": [
            {
                "zip": "0892",
                "pinyin": "Rikaze",
                "name": "日喀则",
                "label": "日喀则Rikaze0892"
            },
            {
                "zip": "0633",
                "pinyin": "Rizhao",
                "name": "日照",
                "label": "日照Rizhao0633"
            },
            {
                "zip": "0768",
                "pinyin": "Raoping",
                "name": "饶平",
                "label": "饶平Raoping0768"
            },
            {
                "zip": "0751",
                "pinyin": "Renhua",
                "name": "仁化",
                "label": "仁化Renhua0751"
            },
            {
                "zip": "0772",
                "pinyin": "Rongan",
                "name": "融安",
                "label": "融安Rongan0772"
            },
            {
                "zip": "023",
                "pinyin": "Rongchang",
                "name": "荣昌",
                "label": "荣昌Rongchang023"
            },
            {
                "zip": "0631",
                "pinyin": "Rongcheng",
                "name": "荣成",
                "label": "荣成Rongcheng0631"
            },
            {
                "zip": "0772",
                "pinyin": "Rongshui",
                "name": "融水",
                "label": "融水Rongshui0772"
            },
            {
                "zip": "0513",
                "pinyin": "Rudong",
                "name": "如东",
                "label": "如东Rudong0513"
            },
            {
                "zip": "0513",
                "pinyin": "Rugao",
                "name": "如皋",
                "label": "如皋Rugao0513"
            },
            {
                "zip": "0577",
                "pinyin": "Ruian",
                "name": "瑞安",
                "label": "瑞安Ruian0577"
            },
            {
                "zip": "0792",
                "pinyin": "Ruichang",
                "name": "瑞昌",
                "label": "瑞昌Ruichang0792"
            },
            {
                "zip": "0797",
                "pinyin": "Ruijin",
                "name": "瑞金",
                "label": "瑞金Ruijin0797"
            },
            {
                "zip": "0631",
                "pinyin": "Rushan",
                "name": "乳山",
                "label": "乳山Rushan0631"
            },
            {
                "zip": "0379",
                "pinyin": "Ruyang",
                "name": "汝阳",
                "label": "汝阳Ruyang0379"
            },
            {
                "zip": "0751",
                "pinyin": "Ruyuan",
                "name": "乳源",
                "label": "乳源Ruyuan0751"
            }
        ]
    },
    {
        "index": "S",
        "citys": [
            {
                "zip": "021",
                "pinyin": "Shanghai",
                "name": "上海",
                "label": "上海Shanghai021"
            },
            {
                "zip": "024",
                "pinyin": "Shenyang",
                "name": "沈阳",
                "label": "沈阳Shenyang024"
            },
            {
                "zip": "0755",
                "pinyin": "Shenzhen",
                "name": "深圳",
                "label": "深圳Shenzhen0755"
            },
            {
                "zip": "0311",
                "pinyin": "Shijiazhuang",
                "name": "石家庄",
                "label": "石家庄Shijiazhuang0311"
            },
            {
                "zip": "0512",
                "pinyin": "Suzhou",
                "name": "苏州",
                "label": "苏州Suzhou0512"
            },
            {
                "zip": "0398",
                "pinyin": "Sanmenxia",
                "name": "三门峡",
                "label": "三门峡Sanmenxia0398"
            },
            {
                "zip": "0598",
                "pinyin": "Sanming",
                "name": "三明",
                "label": "三明Sanming0598"
            },
            {
                "zip": "0899",
                "pinyin": "Sanya",
                "name": "三亚",
                "label": "三亚Sanya0899"
            },
            {
                "zip": "0914",
                "pinyin": "Shangluo",
                "name": "商洛",
                "label": "商洛Shangluo0914"
            },
            {
                "zip": "0370",
                "pinyin": "Shangqiu",
                "name": "商丘",
                "label": "商丘Shangqiu0370"
            },
            {
                "zip": "0793",
                "pinyin": "Shangrao",
                "name": "上饶",
                "label": "上饶Shangrao0793"
            },
            {
                "zip": "0893",
                "pinyin": "Shannan",
                "name": "山南",
                "label": "山南Shannan0893"
            },
            {
                "zip": "0754",
                "pinyin": "Shantou",
                "name": "汕头",
                "label": "汕头Shantou0754"
            },
            {
                "zip": "0660",
                "pinyin": "Shanwei",
                "name": "汕尾",
                "label": "汕尾Shanwei0660"
            },
            {
                "zip": "0751",
                "pinyin": "Shaoguan",
                "name": "韶关",
                "label": "韶关Shaoguan0751"
            },
            {
                "zip": "0575",
                "pinyin": "Shaoxing",
                "name": "绍兴",
                "label": "绍兴Shaoxing0575"
            },
            {
                "zip": "0739",
                "pinyin": "Shaoyang",
                "name": "邵阳",
                "label": "邵阳Shaoyang0739"
            },
            {
                "zip": "0719",
                "pinyin": "Shiyan",
                "name": "十堰",
                "label": "十堰Shiyan0719"
            },
            {
                "zip": "0952",
                "pinyin": "Shizuishan",
                "name": "石嘴山",
                "label": "石嘴山Shizuishan0952"
            },
            {
                "zip": "0469",
                "pinyin": "Shuangyashan",
                "name": "双鸭山",
                "label": "双鸭山Shuangyashan0469"
            },
            {
                "zip": "0349",
                "pinyin": "Shuozhou",
                "name": "朔州",
                "label": "朔州Shuozhou0349"
            },
            {
                "zip": "0434",
                "pinyin": "Siping",
                "name": "四平",
                "label": "四平Siping0434"
            },
            {
                "zip": "0438",
                "pinyin": "Songyuan",
                "name": "松原",
                "label": "松原Songyuan0438"
            },
            {
                "zip": "0455",
                "pinyin": "Suihua",
                "name": "绥化",
                "label": "绥化Suihua0455"
            },
            {
                "zip": "0825",
                "pinyin": "Suining",
                "name": "遂宁",
                "label": "遂宁Suining0825"
            },
            {
                "zip": "0722",
                "pinyin": "Suizhou",
                "name": "随州",
                "label": "随州Suizhou0722"
            },
            {
                "zip": "0527",
                "pinyin": "Suqian",
                "name": "宿迁",
                "label": "宿迁Suqian0527"
            },
            {
                "zip": "0557",
                "pinyin": "Suzhou",
                "name": "宿州",
                "label": "宿州Suzhou0557"
            },
            {
                "zip": "0772",
                "pinyin": "Sanjiang",
                "name": "三江",
                "label": "三江Sanjiang0772"
            },
            {
                "zip": "0576",
                "pinyin": "Sanmen",
                "name": "三门",
                "label": "三门Sanmen0576"
            },
            {
                "zip": "0596",
                "pinyin": "Saoan",
                "name": "诏安",
                "label": "诏安Saoan0596"
            },
            {
                "zip": "0795",
                "pinyin": "Shanggao",
                "name": "上高",
                "label": "上高Shanggao0795"
            },
            {
                "zip": "0597",
                "pinyin": "Shanghang",
                "name": "上杭",
                "label": "上杭Shanghang0597"
            },
            {
                "zip": "0531",
                "pinyin": "Shanghe",
                "name": "商河",
                "label": "商河Shanghe0531"
            },
            {
                "zip": "0799",
                "pinyin": "Shangli",
                "name": "上栗",
                "label": "上栗Shangli0799"
            },
            {
                "zip": "0771",
                "pinyin": "Shanglin",
                "name": "上林",
                "label": "上林Shanglin0771"
            },
            {
                "zip": "0793",
                "pinyin": "Shangrao",
                "name": "上饶",
                "label": "上饶Shangrao0793"
            },
            {
                "zip": "0797",
                "pinyin": "Shangyou",
                "name": "上犹",
                "label": "上犹Shangyou0797"
            },
            {
                "zip": "0575",
                "pinyin": "Shangyu",
                "name": "上虞",
                "label": "上虞Shangyu0575"
            },
            {
                "zip": "0451",
                "pinyin": "Shangzhi",
                "name": "尚志",
                "label": "尚志Shangzhi0451"
            },
            {
                "zip": "0599",
                "pinyin": "Shaowu",
                "name": "邵武",
                "label": "邵武Shaowu0599"
            },
            {
                "zip": "0575",
                "pinyin": "Shaoxing",
                "name": "绍兴",
                "label": "绍兴Shaoxing0575"
            },
            {
                "zip": "0598",
                "pinyin": "Shaxian",
                "name": "沙县",
                "label": "沙县Shaxian0598"
            },
            {
                "zip": "0580",
                "pinyin": "Shengsi",
                "name": "嵊泗",
                "label": "嵊泗Shengsi0580"
            },
            {
                "zip": "0575",
                "pinyin": "Shengzhou",
                "name": "嵊州",
                "label": "嵊州Shengzhou0575"
            },
            {
                "zip": "0635",
                "pinyin": "Shenxian",
                "name": "莘县",
                "label": "莘县Shenxian0635"
            },
            {
                "zip": "0311",
                "pinyin": "Shenze",
                "name": "深泽",
                "label": "深泽Shenze0311"
            },
            {
                "zip": "0559",
                "pinyin": "Shexian",
                "name": "歙县",
                "label": "歙县Shexian0559"
            },
            {
                "zip": "0515",
                "pinyin": "Sheyang",
                "name": "射阳",
                "label": "射阳Sheyang0515"
            },
            {
                "zip": "0797",
                "pinyin": "Shicheng",
                "name": "石城",
                "label": "石城Shicheng0797"
            },
            {
                "zip": "0871",
                "pinyin": "Shilin",
                "name": "石林",
                "label": "石林Shilin0871"
            },
            {
                "zip": "0595",
                "pinyin": "Shishi",
                "name": "石狮",
                "label": "石狮Shishi0595"
            },
            {
                "zip": "0566",
                "pinyin": "Shitai",
                "name": "石台",
                "label": "石台Shitai0566"
            },
            {
                "zip": "0751",
                "pinyin": "Shixing",
                "name": "始兴",
                "label": "始兴Shixing0751"
            },
            {
                "zip": "023",
                "pinyin": "Shizhu",
                "name": "石柱",
                "label": "石柱Shizhu023"
            },
            {
                "zip": "0536",
                "pinyin": "Shouguang",
                "name": "寿光",
                "label": "寿光Shouguang0536"
            },
            {
                "zip": "0593",
                "pinyin": "Shouning",
                "name": "寿宁",
                "label": "寿宁Shouning0593"
            },
            {
                "zip": "0564",
                "pinyin": "Shouxian",
                "name": "寿县",
                "label": "寿县Shouxian0564"
            },
            {
                "zip": "0451",
                "pinyin": "Shuangcheng",
                "name": "双城",
                "label": "双城Shuangcheng0451"
            },
            {
                "zip": "028",
                "pinyin": "Shuangliu",
                "name": "双流",
                "label": "双流Shuangliu028"
            },
            {
                "zip": "0564",
                "pinyin": "Shucheng",
                "name": "舒城",
                "label": "舒城Shucheng0564"
            },
            {
                "zip": "0423",
                "pinyin": "Shulan",
                "name": "舒兰",
                "label": "舒兰Shulan0423"
            },
            {
                "zip": "0599",
                "pinyin": "Shunchang",
                "name": "顺昌",
                "label": "顺昌Shunchang0599"
            },
            {
                "zip": "0527",
                "pinyin": "Shuyang",
                "name": "沭阳",
                "label": "沭阳Shuyang0527"
            },
            {
                "zip": "0527",
                "pinyin": "Sihong",
                "name": "泗洪",
                "label": "泗洪Sihong0527"
            },
            {
                "zip": "0758",
                "pinyin": "Sihui",
                "name": "四会",
                "label": "四会Sihui0758"
            },
            {
                "zip": "0537",
                "pinyin": "Sishui",
                "name": "泗水",
                "label": "泗水Sishui0537"
            },
            {
                "zip": "0557",
                "pinyin": "Sixian",
                "name": "泗县",
                "label": "泗县Sixian0557"
            },
            {
                "zip": "0527",
                "pinyin": "Siyang",
                "name": "泗阳",
                "label": "泗阳Siyang0527"
            },
            {
                "zip": "0871",
                "pinyin": "Songming",
                "name": "嵩明",
                "label": "嵩明Songming0871"
            },
            {
                "zip": "0599",
                "pinyin": "Songxi",
                "name": "松溪",
                "label": "松溪Songxi0599"
            },
            {
                "zip": "0379",
                "pinyin": "Songxian",
                "name": "嵩县",
                "label": "嵩县Songxian0379"
            },
            {
                "zip": "0578",
                "pinyin": "Songyang",
                "name": "松阳",
                "label": "松阳Songyang0578"
            },
            {
                "zip": "0578",
                "pinyin": "Suichang",
                "name": "遂昌",
                "label": "遂昌Suichang0578"
            },
            {
                "zip": "0796",
                "pinyin": "Suichuan",
                "name": "遂川",
                "label": "遂川Suichuan0796"
            },
            {
                "zip": "0516",
                "pinyin": "Suining",
                "name": "睢宁",
                "label": "睢宁Suining0516"
            },
            {
                "zip": "0561",
                "pinyin": "Suixi",
                "name": "濉溪",
                "label": "濉溪Suixi0561"
            },
            {
                "zip": "0759",
                "pinyin": "Suixi",
                "name": "遂溪",
                "label": "遂溪Suixi0759"
            },
            {
                "zip": "0556",
                "pinyin": "Susong",
                "name": "宿松",
                "label": "宿松Susong0556"
            },
            {
                "zip": "0527",
                "pinyin": "Suyu",
                "name": "宿豫",
                "label": "宿豫Suyu0527"
            }
        ]
    },
    {
        "index": "T",
        "citys": [
            {
                "zip": "022",
                "pinyin": "Tianjin",
                "name": "天津",
                "label": "天津Tianjin022"
            },
            {
                "zip": "0576",
                "pinyin": "Taizhou",
                "name": "台州",
                "label": "台州Taizhou0576"
            },
            {
                "zip": "0315",
                "pinyin": "Tangshan",
                "name": "唐山",
                "label": "唐山Tangshan0315"
            },
            {
                "zip": "0901",
                "pinyin": "Tachengdi",
                "name": "塔城地",
                "label": "塔城地Tachengdi0901"
            },
            {
                "zip": "0538",
                "pinyin": "Taian",
                "name": "泰安",
                "label": "泰安Taian0538"
            },
            {
                "zip": "0351",
                "pinyin": "Taiyuan",
                "name": "太原",
                "label": "太原Taiyuan0351"
            },
            {
                "zip": "0523",
                "pinyin": "Taizhou",
                "name": "泰州",
                "label": "泰州Taizhou0523"
            },
            {
                "zip": "0938",
                "pinyin": "Tianshui",
                "name": "天水",
                "label": "天水Tianshui0938"
            },
            {
                "zip": "0410",
                "pinyin": "Tieling",
                "name": "铁岭",
                "label": "铁岭Tieling0410"
            },
            {
                "zip": "0919",
                "pinyin": "Tongchuan",
                "name": "铜川",
                "label": "铜川Tongchuan0919"
            },
            {
                "zip": "0435",
                "pinyin": "Tonghua",
                "name": "通化",
                "label": "通化Tonghua0435"
            },
            {
                "zip": "0475",
                "pinyin": "Tongliao",
                "name": "通辽",
                "label": "通辽Tongliao0475"
            },
            {
                "zip": "0562",
                "pinyin": "Tongling",
                "name": "铜陵",
                "label": "铜陵Tongling0562"
            },
            {
                "zip": "0856",
                "pinyin": "Tongren",
                "name": "铜仁",
                "label": "铜仁Tongren0856"
            },
            {
                "zip": "0995",
                "pinyin": "Tulufan",
                "name": "吐鲁番",
                "label": "吐鲁番Tulufan0995"
            },
            {
                "zip": "0512",
                "pinyin": "Taicang",
                "name": "太仓",
                "label": "太仓Taicang0512"
            },
            {
                "zip": "0558",
                "pinyin": "Taihe",
                "name": "太和",
                "label": "太和Taihe0558"
            },
            {
                "zip": "0796",
                "pinyin": "Taihe",
                "name": "泰和",
                "label": "泰和Taihe0796"
            },
            {
                "zip": "0556",
                "pinyin": "Taihu",
                "name": "太湖",
                "label": "太湖Taihu0556"
            },
            {
                "zip": "0598",
                "pinyin": "Taining",
                "name": "泰宁",
                "label": "泰宁Taining0598"
            },
            {
                "zip": "0750",
                "pinyin": "Taishan",
                "name": "台山",
                "label": "台山Taishan0750"
            },
            {
                "zip": "0577",
                "pinyin": "Taishun",
                "name": "泰顺",
                "label": "泰顺Taishun0577"
            },
            {
                "zip": "0523",
                "pinyin": "Taixing",
                "name": "泰兴",
                "label": "泰兴Taixing0523"
            },
            {
                "zip": "0539",
                "pinyin": "Tancheng",
                "name": "郯城",
                "label": "郯城Tancheng0539"
            },
            {
                "zip": "0315",
                "pinyin": "Tanghai",
                "name": "唐海",
                "label": "唐海Tanghai0315"
            },
            {
                "zip": "0623",
                "pinyin": "Tengzhou",
                "name": "滕州",
                "label": "滕州Tengzhou0623"
            },
            {
                "zip": "0550",
                "pinyin": "Tianchang",
                "name": "天长",
                "label": "天长Tianchang0550"
            },
            {
                "zip": "0576",
                "pinyin": "Tiantai",
                "name": "天台",
                "label": "天台Tiantai0576"
            },
            {
                "zip": "0556",
                "pinyin": "Tongcheng",
                "name": "桐城",
                "label": "桐城Tongcheng0556"
            },
            {
                "zip": "0795",
                "pinyin": "Tonggu",
                "name": "铜鼓",
                "label": "铜鼓Tonggu0795"
            },
            {
                "zip": "0451",
                "pinyin": "Tonghe",
                "name": "通河",
                "label": "通河Tonghe0451"
            },
            {
                "zip": "023",
                "pinyin": "Tongliang",
                "name": "铜梁",
                "label": "铜梁Tongliang023"
            },
            {
                "zip": "0562",
                "pinyin": "Tongling",
                "name": "铜陵",
                "label": "铜陵Tongling0562"
            },
            {
                "zip": "0571",
                "pinyin": "Tonglu",
                "name": "桐庐",
                "label": "桐庐Tonglu0571"
            },
            {
                "zip": "023",
                "pinyin": "Tongnan",
                "name": "潼南",
                "label": "潼南Tongnan023"
            },
            {
                "zip": "0516",
                "pinyin": "Tongshan",
                "name": "铜山",
                "label": "铜山Tongshan0516"
            },
            {
                "zip": "0573",
                "pinyin": "Tongxiang",
                "name": "桐乡",
                "label": "桐乡Tongxiang0573"
            },
            {
                "zip": "0513",
                "pinyin": "Tongzhou",
                "name": "通州",
                "label": "通州Tongzhou0513"
            }
        ]
    },
    {
        "index": "W",
        "citys": [
            {
                "zip": "0536",
                "pinyin": "Weifang",
                "name": "潍坊",
                "label": "潍坊Weifang0536"
            },
            {
                "zip": "0631",
                "pinyin": "Weihai",
                "name": "威海",
                "label": "威海Weihai0631"
            },
            {
                "zip": "027",
                "pinyin": "Wuhan",
                "name": "武汉",
                "label": "武汉Wuhan027"
            },
            {
                "zip": "0510",
                "pinyin": "Wuxi",
                "name": "无锡",
                "label": "无锡Wuxi0510"
            },
            {
                "zip": "0913",
                "pinyin": "Weinan",
                "name": "渭南",
                "label": "渭南Weinan0913"
            },
            {
                "zip": "0876",
                "pinyin": "Wenshan",
                "name": "文山",
                "label": "文山Wenshan0876"
            },
            {
                "zip": "0577",
                "pinyin": "Wenzhou",
                "name": "温州",
                "label": "温州Wenzhou0577"
            },
            {
                "zip": "0473",
                "pinyin": "Wuhai",
                "name": "乌海",
                "label": "乌海Wuhai0473"
            },
            {
                "zip": "0553",
                "pinyin": "Wuhu",
                "name": "芜湖",
                "label": "芜湖Wuhu0553"
            },
            {
                "zip": "0474",
                "pinyin": "Wulanchabu",
                "name": "乌兰察布",
                "label": "乌兰察布Wulanchabu0474"
            },
            {
                "zip": "0991",
                "pinyin": "Wulumuqi",
                "name": "乌鲁木齐",
                "label": "乌鲁木齐Wulumuqi0991"
            },
            {
                "zip": "0935",
                "pinyin": "Wuwei",
                "name": "武威",
                "label": "武威Wuwei0935"
            },
            {
                "zip": "0953",
                "pinyin": "Wuzhong",
                "name": "吴忠",
                "label": "吴忠Wuzhong0953"
            },
            {
                "zip": "0774",
                "pinyin": "Wuzhou",
                "name": "梧州",
                "label": "梧州Wuzhou0774"
            },
            {
                "zip": "0411",
                "pinyin": "Wafangdian",
                "name": "瓦房店",
                "label": "瓦房店Wafangdian0411"
            },
            {
                "zip": "0796",
                "pinyin": "Wanan",
                "name": "万安",
                "label": "万安Wanan0796"
            },
            {
                "zip": "0731",
                "pinyin": "Wangcheng",
                "name": "望城",
                "label": "望城Wangcheng0731"
            },
            {
                "zip": "0556",
                "pinyin": "Wangjiang",
                "name": "望江",
                "label": "望江Wangjiang0556"
            },
            {
                "zip": "0793",
                "pinyin": "Wannian",
                "name": "万年",
                "label": "万年Wannian0793"
            },
            {
                "zip": "0795",
                "pinyin": "Wanzai",
                "name": "万载",
                "label": "万载Wanzai0795"
            },
            {
                "zip": "0537",
                "pinyin": "Weishan",
                "name": "微山",
                "label": "微山Weishan0537"
            },
            {
                "zip": "0577",
                "pinyin": "Wencheng",
                "name": "文成",
                "label": "文成Wencheng0577"
            },
            {
                "zip": "0631",
                "pinyin": "Wendeng",
                "name": "文登",
                "label": "文登Wendeng0631"
            },
            {
                "zip": "0751",
                "pinyin": "Wengyuan",
                "name": "翁源",
                "label": "翁源Wengyuan0751"
            },
            {
                "zip": "0576",
                "pinyin": "Wenling",
                "name": "温岭",
                "label": "温岭Wenling0576"
            },
            {
                "zip": "0537",
                "pinyin": "Wenshang",
                "name": "汶上",
                "label": "汶上Wenshang0537"
            },
            {
                "zip": "0391",
                "pinyin": "Wenxian",
                "name": "温县",
                "label": "温县Wenxian0391"
            },
            {
                "zip": "0558",
                "pinyin": "Woyang",
                "name": "涡阳",
                "label": "涡阳Woyang0558"
            },
            {
                "zip": "0451",
                "pinyin": "Wuchang",
                "name": "五常",
                "label": "五常Wuchang0451"
            },
            {
                "zip": "0534",
                "pinyin": "Wucheng",
                "name": "武城",
                "label": "武城Wucheng0534"
            },
            {
                "zip": "0759",
                "pinyin": "Wuchuan",
                "name": "吴川",
                "label": "吴川Wuchuan0759"
            },
            {
                "zip": "0543",
                "pinyin": "Wudi",
                "name": "无棣",
                "label": "无棣Wudi0543"
            },
            {
                "zip": "0552",
                "pinyin": "Wuhe",
                "name": "五河",
                "label": "五河Wuhe0552"
            },
            {
                "zip": "0553",
                "pinyin": "Wuhu",
                "name": "芜湖",
                "label": "芜湖Wuhu0553"
            },
            {
                "zip": "0753",
                "pinyin": "Wuhua",
                "name": "五华",
                "label": "五华Wuhua0753"
            },
            {
                "zip": "0311",
                "pinyin": "Wuji",
                "name": "无极",
                "label": "无极Wuji0311"
            },
            {
                "zip": "0512",
                "pinyin": "Wujiang",
                "name": "吴江",
                "label": "吴江Wujiang0512"
            },
            {
                "zip": "0633",
                "pinyin": "Wulian",
                "name": "五莲",
                "label": "五莲Wulian0633"
            },
            {
                "zip": "023",
                "pinyin": "Wulong",
                "name": "武隆",
                "label": "武隆Wulong023"
            },
            {
                "zip": "0771",
                "pinyin": "Wuming",
                "name": "武鸣",
                "label": "武鸣Wuming0771"
            },
            {
                "zip": "0792",
                "pinyin": "Wuning",
                "name": "武宁",
                "label": "武宁Wuning0792"
            },
            {
                "zip": "0597",
                "pinyin": "Wuping",
                "name": "武平",
                "label": "武平Wuping0597"
            },
            {
                "zip": "023",
                "pinyin": "Wushan",
                "name": "巫山",
                "label": "巫山Wushan023"
            },
            {
                "zip": "0565",
                "pinyin": "Wuwei",
                "name": "无为",
                "label": "无为Wuwei0565"
            },
            {
                "zip": "023",
                "pinyin": "Wuxi",
                "name": "巫溪",
                "label": "巫溪Wuxi023"
            },
            {
                "zip": "0579",
                "pinyin": "Wuyi",
                "name": "武义",
                "label": "武义Wuyi0579"
            },
            {
                "zip": "0599",
                "pinyin": "Wuyishan",
                "name": "武夷山",
                "label": "武夷山Wuyishan0599"
            },
            {
                "zip": "0793",
                "pinyin": "Wuyuan",
                "name": "婺源",
                "label": "婺源Wuyuan0793"
            },
            {
                "zip": "0391",
                "pinyin": "Wuzhi",
                "name": "武陟",
                "label": "武陟Wuzhi0391"
            }
        ]
    },
    {
        "index": "X",
        "citys": [
            {
                "zip": "0592",
                "pinyin": "Xiamen",
                "name": "厦门",
                "label": "厦门Xiamen0592"
            },
            {
                "zip": "029",
                "pinyin": "Xian",
                "name": "西安",
                "label": "西安Xian029"
            },
            {
                "zip": "0374",
                "pinyin": "Xuchang",
                "name": "许昌",
                "label": "许昌Xuchang0374"
            },
            {
                "zip": "0516",
                "pinyin": "Xuzhou",
                "name": "徐州",
                "label": "徐州Xuzhou0516"
            },
            {
                "zip": "0710",
                "pinyin": "Xiangfan",
                "name": "襄樊",
                "label": "襄樊Xiangfan0710"
            },
            {
                "zip": "0732",
                "pinyin": "Xiangtan",
                "name": "湘潭",
                "label": "湘潭Xiangtan0732"
            },
            {
                "zip": "0743",
                "pinyin": "Xiangxi",
                "name": "湘西",
                "label": "湘西Xiangxi0743"
            },
            {
                "zip": "0715",
                "pinyin": "Xianning",
                "name": "咸宁",
                "label": "咸宁Xianning0715"
            },
            {
                "zip": "029",
                "pinyin": "Xianyang",
                "name": "咸阳",
                "label": "咸阳Xianyang029"
            },
            {
                "zip": "0712",
                "pinyin": "Xiaogan",
                "name": "孝感",
                "label": "孝感Xiaogan0712"
            },
            {
                "zip": "0479",
                "pinyin": "Xilinguolemeng",
                "name": "锡林郭勒盟",
                "label": "锡林郭勒盟Xilinguolemeng0479"
            },
            {
                "zip": "0482",
                "pinyin": "Xinganmeng",
                "name": "兴安盟",
                "label": "兴安盟Xinganmeng0482"
            },
            {
                "zip": "0319",
                "pinyin": "Xingtai",
                "name": "邢台",
                "label": "邢台Xingtai0319"
            },
            {
                "zip": "0971",
                "pinyin": "Xining",
                "name": "西宁",
                "label": "西宁Xining0971"
            },
            {
                "zip": "0373",
                "pinyin": "Xinxiang",
                "name": "新乡",
                "label": "新乡Xinxiang0373"
            },
            {
                "zip": "0376",
                "pinyin": "Xinyang",
                "name": "信阳",
                "label": "信阳Xinyang0376"
            },
            {
                "zip": "0790",
                "pinyin": "Xinyu",
                "name": "新余",
                "label": "新余Xinyu0790"
            },
            {
                "zip": "0350",
                "pinyin": "Xinzhou",
                "name": "忻州",
                "label": "忻州Xinzhou0350"
            },
            {
                "zip": "0691",
                "pinyin": "Xishuangbanna",
                "name": "西双版纳",
                "label": "西双版纳Xishuangbanna0691"
            },
            {
                "zip": "0563",
                "pinyin": "Xuancheng",
                "name": "宣城",
                "label": "宣城Xuancheng0563"
            },
            {
                "zip": "0796",
                "pinyin": "Xiajiang",
                "name": "峡江",
                "label": "峡江Xiajiang0796"
            },
            {
                "zip": "0534",
                "pinyin": "Xiajin",
                "name": "夏津",
                "label": "夏津Xiajin0534"
            },
            {
                "zip": "0574",
                "pinyin": "Xiangshan",
                "name": "象山",
                "label": "象山Xiangshan0574"
            },
            {
                "zip": "0515",
                "pinyin": "Xiangshui",
                "name": "响水",
                "label": "响水Xiangshui0515"
            },
            {
                "zip": "0576",
                "pinyin": "Xianju",
                "name": "仙居",
                "label": "仙居Xianju0576"
            },
            {
                "zip": "0594",
                "pinyin": "Xianyou",
                "name": "仙游",
                "label": "仙游Xianyou0594"
            },
            {
                "zip": "0557",
                "pinyin": "Xiaoxian",
                "name": "萧县",
                "label": "萧县Xiaoxian0557"
            },
            {
                "zip": "0593",
                "pinyin": "Xiapu",
                "name": "霞浦",
                "label": "霞浦Xiapu0593"
            },
            {
                "zip": "0851",
                "pinyin": "Xifeng",
                "name": "息烽",
                "label": "息烽Xifeng0851"
            },
            {
                "zip": "0379",
                "pinyin": "Xinan",
                "name": "新安",
                "label": "新安Xinan0379"
            },
            {
                "zip": "0575",
                "pinyin": "Xinchang",
                "name": "新昌",
                "label": "新昌Xinchang0575"
            },
            {
                "zip": "0797",
                "pinyin": "Xinfeng",
                "name": "信丰",
                "label": "信丰Xinfeng0797"
            },
            {
                "zip": "0751",
                "pinyin": "Xinfeng",
                "name": "新丰",
                "label": "新丰Xinfeng0751"
            },
            {
                "zip": "0796",
                "pinyin": "Xingan",
                "name": "新干",
                "label": "新干Xingan0796"
            },
            {
                "zip": "0797",
                "pinyin": "Xingguo",
                "name": "兴国",
                "label": "兴国Xingguo0797"
            },
            {
                "zip": "0523",
                "pinyin": "Xinghua",
                "name": "兴化",
                "label": "兴化Xinghua0523"
            },
            {
                "zip": "0753",
                "pinyin": "Xingning",
                "name": "兴宁",
                "label": "兴宁Xingning0753"
            },
            {
                "zip": "0311",
                "pinyin": "Xingtang",
                "name": "行唐",
                "label": "行唐Xingtang0311"
            },
            {
                "zip": "0371",
                "pinyin": "Xingyang",
                "name": "荥阳",
                "label": "荥阳Xingyang0371"
            },
            {
                "zip": "0792",
                "pinyin": "Xingzi",
                "name": "星子",
                "label": "星子Xingzi0792"
            },
            {
                "zip": "0311",
                "pinyin": "Xinji",
                "name": "辛集",
                "label": "辛集Xinji0311"
            },
            {
                "zip": "0791",
                "pinyin": "Xinjian",
                "name": "新建",
                "label": "新建Xinjian0791"
            },
            {
                "zip": "028",
                "pinyin": "Xinjin",
                "name": "新津",
                "label": "新津Xinjin028"
            },
            {
                "zip": "0311",
                "pinyin": "Xinle",
                "name": "新乐",
                "label": "新乐Xinle0311"
            },
            {
                "zip": "024",
                "pinyin": "Xinmin",
                "name": "新民",
                "label": "新民Xinmin024"
            },
            {
                "zip": "0371",
                "pinyin": "Xinmi",
                "name": "新密",
                "label": "新密Xinmi0371"
            },
            {
                "zip": "0538",
                "pinyin": "Xintai",
                "name": "新泰",
                "label": "新泰Xintai0538"
            },
            {
                "zip": "0766",
                "pinyin": "Xinxing",
                "name": "新兴",
                "label": "新兴Xinxing0766"
            },
            {
                "zip": "0516",
                "pinyin": "Xinyi",
                "name": "新沂",
                "label": "新沂Xinyi0516"
            },
            {
                "zip": "0668",
                "pinyin": "Xinyi",
                "name": "信宜",
                "label": "信宜Xinyi0668"
            },
            {
                "zip": "0371",
                "pinyin": "Xinzheng",
                "name": "新郑",
                "label": "新郑Xinzheng0371"
            },
            {
                "zip": "0559",
                "pinyin": "Xiuning",
                "name": "休宁",
                "label": "休宁Xiuning0559"
            },
            {
                "zip": "023",
                "pinyin": "Xiushan",
                "name": "秀山",
                "label": "秀山Xiushan023"
            },
            {
                "zip": "0792",
                "pinyin": "Xiushui",
                "name": "修水",
                "label": "修水Xiushui0792"
            },
            {
                "zip": "0851",
                "pinyin": "Xiuwen",
                "name": "修文",
                "label": "修文Xiuwen0851"
            },
            {
                "zip": "0391",
                "pinyin": "Xiuwu",
                "name": "修武",
                "label": "修武Xiuwu0391"
            },
            {
                "zip": "0871",
                "pinyin": "Xundian",
                "name": "寻甸",
                "label": "寻甸Xundian0871"
            },
            {
                "zip": "0797",
                "pinyin": "Xunwu",
                "name": "寻乌",
                "label": "寻乌Xunwu0797"
            },
            {
                "zip": "0759",
                "pinyin": "Xuwen",
                "name": "徐闻",
                "label": "徐闻Xuwen0759"
            },
            {
                "zip": "0517",
                "pinyin": "Xuyi",
                "name": "盱眙",
                "label": "盱眙Xuyi0517"
            }
        ]
    },
    {
        "index": "Y",
        "citys": [
            {
                "zip": "0514",
                "pinyin": "Yangzhou",
                "name": "扬州",
                "label": "扬州Yangzhou0514"
            },
            {
                "zip": "0535",
                "pinyin": "Yantai",
                "name": "烟台",
                "label": "烟台Yantai0535"
            },
            {
                "zip": "0835",
                "pinyin": "Yaan",
                "name": "雅安",
                "label": "雅安Yaan0835"
            },
            {
                "zip": "0911",
                "pinyin": "Yanan",
                "name": "延安",
                "label": "延安Yanan0911"
            },
            {
                "zip": "0433",
                "pinyin": "Yanbian",
                "name": "延边",
                "label": "延边Yanbian0433"
            },
            {
                "zip": "0515",
                "pinyin": "Yancheng",
                "name": "盐城",
                "label": "盐城Yancheng0515"
            },
            {
                "zip": "0662",
                "pinyin": "Yangjiang",
                "name": "阳江",
                "label": "阳江Yangjiang0662"
            },
            {
                "zip": "0353",
                "pinyin": "Yangquan",
                "name": "阳泉",
                "label": "阳泉Yangquan0353"
            },
            {
                "zip": "0831",
                "pinyin": "Yibin",
                "name": "宜宾",
                "label": "宜宾Yibin0831"
            },
            {
                "zip": "0717",
                "pinyin": "Yichang",
                "name": "宜昌",
                "label": "宜昌Yichang0717"
            },
            {
                "zip": "0458",
                "pinyin": "Yichun",
                "name": "伊春",
                "label": "伊春Yichun0458"
            },
            {
                "zip": "0795",
                "pinyin": "Yichun",
                "name": "宜春",
                "label": "宜春Yichun0795"
            },
            {
                "zip": "0999",
                "pinyin": "Yilihasake",
                "name": "伊犁哈萨克",
                "label": "伊犁哈萨克Yilihasake0999"
            },
            {
                "zip": "0951",
                "pinyin": "Yinchuan",
                "name": "银川",
                "label": "银川Yinchuan0951"
            },
            {
                "zip": "0417",
                "pinyin": "Yingkou",
                "name": "营口",
                "label": "营口Yingkou0417"
            },
            {
                "zip": "0701",
                "pinyin": "Yingtan",
                "name": "鹰潭",
                "label": "鹰潭Yingtan0701"
            },
            {
                "zip": "0737",
                "pinyin": "Yiyang",
                "name": "益阳",
                "label": "益阳Yiyang0737"
            },
            {
                "zip": "0746",
                "pinyin": "Yongzhou",
                "name": "永州",
                "label": "永州Yongzhou0746"
            },
            {
                "zip": "0730",
                "pinyin": "Yueyang",
                "name": "岳阳",
                "label": "岳阳Yueyang0730"
            },
            {
                "zip": "0775",
                "pinyin": "Yulin",
                "name": "玉林",
                "label": "玉林Yulin0775"
            },
            {
                "zip": "0912",
                "pinyin": "Yulin",
                "name": "榆林",
                "label": "榆林Yulin0912"
            },
            {
                "zip": "0359",
                "pinyin": "Yuncheng",
                "name": "运城",
                "label": "运城Yuncheng0359"
            },
            {
                "zip": "0766",
                "pinyin": "Yunfu",
                "name": "云浮",
                "label": "云浮Yunfu0766"
            },
            {
                "zip": "0976",
                "pinyin": "Yushu",
                "name": "玉树",
                "label": "玉树Yushu0976"
            },
            {
                "zip": "0877",
                "pinyin": "Yuxi",
                "name": "玉溪",
                "label": "玉溪Yuxi0877"
            },
            {
                "zip": "0662",
                "pinyin": "Yangchun",
                "name": "阳春",
                "label": "阳春Yangchun0662"
            },
            {
                "zip": "0662",
                "pinyin": "Yangdong",
                "name": "阳东",
                "label": "阳东Yangdong0662"
            },
            {
                "zip": "0635",
                "pinyin": "Yanggu",
                "name": "阳谷",
                "label": "阳谷Yanggu0635"
            },
            {
                "zip": "0763",
                "pinyin": "Yangshan",
                "name": "阳山",
                "label": "阳山Yangshan0763"
            },
            {
                "zip": "0543",
                "pinyin": "Yangxin",
                "name": "阳信",
                "label": "阳信Yangxin0543"
            },
            {
                "zip": "0662",
                "pinyin": "Yangxi",
                "name": "阳西",
                "label": "阳西Yangxi0662"
            },
            {
                "zip": "0511",
                "pinyin": "Yangzhong",
                "name": "扬中",
                "label": "扬中Yangzhong0511"
            },
            {
                "zip": "0379",
                "pinyin": "Yanshi",
                "name": "偃师",
                "label": "偃师Yanshi0379"
            },
            {
                "zip": "0451",
                "pinyin": "Yanshou",
                "name": "延寿",
                "label": "延寿Yanshou0451"
            },
            {
                "zip": "0537",
                "pinyin": "Yanzhou",
                "name": "兖州",
                "label": "兖州Yanzhou0537"
            },
            {
                "zip": "0379",
                "pinyin": "Yichuan",
                "name": "伊川",
                "label": "伊川Yichuan0379"
            },
            {
                "zip": "0795",
                "pinyin": "Yifeng",
                "name": "宜丰",
                "label": "宜丰Yifeng0795"
            },
            {
                "zip": "0794",
                "pinyin": "Yihuang",
                "name": "宜黄",
                "label": "宜黄Yihuang0794"
            },
            {
                "zip": "0451",
                "pinyin": "Yilan",
                "name": "依兰",
                "label": "依兰Yilan0451"
            },
            {
                "zip": "0871",
                "pinyin": "Yiliang",
                "name": "宜良",
                "label": "宜良Yiliang0871"
            },
            {
                "zip": "0539",
                "pinyin": "Yinan",
                "name": "沂南",
                "label": "沂南Yinan0539"
            },
            {
                "zip": "0763",
                "pinyin": "Yingde",
                "name": "英德",
                "label": "英德Yingde0763"
            },
            {
                "zip": "0558",
                "pinyin": "Yingshang",
                "name": "颍上",
                "label": "颍上Yingshang0558"
            },
            {
                "zip": "0539",
                "pinyin": "Yishui",
                "name": "沂水",
                "label": "沂水Yishui0539"
            },
            {
                "zip": "0579",
                "pinyin": "Yiwu",
                "name": "义乌",
                "label": "义乌Yiwu0579"
            },
            {
                "zip": "0559",
                "pinyin": "Yixian",
                "name": "黟县",
                "label": "黟县Yixian0559"
            },
            {
                "zip": "0510",
                "pinyin": "Yixing",
                "name": "宜兴",
                "label": "宜兴Yixing0510"
            },
            {
                "zip": "0793",
                "pinyin": "Yiyang",
                "name": "弋阳",
                "label": "弋阳Yiyang0793"
            },
            {
                "zip": "0379",
                "pinyin": "Yiyang",
                "name": "宜阳",
                "label": "宜阳Yiyang0379"
            },
            {
                "zip": "0533",
                "pinyin": "Yiyuan",
                "name": "沂源",
                "label": "沂源Yiyuan0533"
            },
            {
                "zip": "0514",
                "pinyin": "Yizheng",
                "name": "仪征",
                "label": "仪征Yizheng0514"
            },
            {
                "zip": "0598",
                "pinyin": "Yongan",
                "name": "永安",
                "label": "永安Yongan0598"
            },
            {
                "zip": "023",
                "pinyin": "Yongchuan",
                "name": "永川",
                "label": "永川Yongchuan023"
            },
            {
                "zip": "0595",
                "pinyin": "Yongchun",
                "name": "永春",
                "label": "永春Yongchun0595"
            },
            {
                "zip": "0931",
                "pinyin": "Yongdeng",
                "name": "永登",
                "label": "永登Yongdeng0931"
            },
            {
                "zip": "0597",
                "pinyin": "Yongding",
                "name": "永定",
                "label": "永定Yongding0597"
            },
            {
                "zip": "0796",
                "pinyin": "Yongfeng",
                "name": "永丰",
                "label": "永丰Yongfeng0796"
            },
            {
                "zip": "0423",
                "pinyin": "Yongji",
                "name": "永吉",
                "label": "永吉Yongji0423"
            },
            {
                "zip": "0577",
                "pinyin": "Yongjia",
                "name": "永嘉",
                "label": "永嘉Yongjia0577"
            },
            {
                "zip": "0579",
                "pinyin": "Yongkang",
                "name": "永康",
                "label": "永康Yongkang0579"
            },
            {
                "zip": "0771",
                "pinyin": "Yongning",
                "name": "邕宁",
                "label": "邕宁Yongning0771"
            },
            {
                "zip": "0591",
                "pinyin": "Yongtai",
                "name": "永泰",
                "label": "永泰Yongtai0591"
            },
            {
                "zip": "0796",
                "pinyin": "Yongxin",
                "name": "永新",
                "label": "永新Yongxin0796"
            },
            {
                "zip": "0792",
                "pinyin": "Yongxiu",
                "name": "永修",
                "label": "永修Yongxiu0792"
            },
            {
                "zip": "0598",
                "pinyin": "Youxi",
                "name": "尤溪",
                "label": "尤溪Youxi0598"
            },
            {
                "zip": "023",
                "pinyin": "Youyang",
                "name": "酉阳",
                "label": "酉阳Youyang023"
            },
            {
                "zip": "0311",
                "pinyin": "Yuanshi",
                "name": "元氏",
                "label": "元氏Yuanshi0311"
            },
            {
                "zip": "0534",
                "pinyin": "Yucheng",
                "name": "禹城",
                "label": "禹城Yucheng0534"
            },
            {
                "zip": "0797",
                "pinyin": "Yudu",
                "name": "于都",
                "label": "于都Yudu0797"
            },
            {
                "zip": "0556",
                "pinyin": "Yuexi",
                "name": "岳西",
                "label": "岳西Yuexi0556"
            },
            {
                "zip": "0793",
                "pinyin": "Yugan",
                "name": "余干",
                "label": "余干Yugan0793"
            },
            {
                "zip": "0576",
                "pinyin": "Yuhuan",
                "name": "玉环",
                "label": "玉环Yuhuan0576"
            },
            {
                "zip": "0701",
                "pinyin": "Yujiang",
                "name": "余江",
                "label": "余江Yujiang0701"
            },
            {
                "zip": "0766",
                "pinyin": "Yunan",
                "name": "郁南",
                "label": "郁南Yunan0766"
            },
            {
                "zip": "0766",
                "pinyin": "Yunan",
                "name": "云安",
                "label": "云安Yunan0766"
            },
            {
                "zip": "0530",
                "pinyin": "Yuncheng",
                "name": "郓城",
                "label": "郓城Yuncheng0530"
            },
            {
                "zip": "0578",
                "pinyin": "Yunhe",
                "name": "云和",
                "label": "云和Yunhe0578"
            },
            {
                "zip": "0596",
                "pinyin": "Yunxiao",
                "name": "云霄",
                "label": "云霄Yunxiao0596"
            },
            {
                "zip": "023",
                "pinyin": "Yunyang",
                "name": "云阳",
                "label": "云阳Yunyang023"
            },
            {
                "zip": "0793",
                "pinyin": "Yushan",
                "name": "玉山",
                "label": "玉山Yushan0793"
            },
            {
                "zip": "0431",
                "pinyin": "Yushu",
                "name": "榆树",
                "label": "榆树Yushu0431"
            },
            {
                "zip": "0537",
                "pinyin": "Yutai",
                "name": "鱼台",
                "label": "鱼台Yutai0537"
            },
            {
                "zip": "0315",
                "pinyin": "Yutian",
                "name": "玉田",
                "label": "玉田Yutian0315"
            },
            {
                "zip": "0574",
                "pinyin": "Yuyao",
                "name": "余姚",
                "label": "余姚Yuyao0574"
            },
            {
                "zip": "0931",
                "pinyin": "Yuzhong",
                "name": "榆中",
                "label": "榆中Yuzhong0931"
            }
        ]
    },
    {
        "index": "Z",
        "citys": [
            {
                "zip": "0596",
                "pinyin": "Zhangzhou",
                "name": "漳州",
                "label": "漳州Zhangzhou0596"
            },
            {
                "zip": "0371",
                "pinyin": "Zhengzhou",
                "name": "郑州",
                "label": "郑州Zhengzhou0371"
            },
            {
                "zip": "0760",
                "pinyin": "Zhongshan",
                "name": "中山",
                "label": "中山Zhongshan0760"
            },
            {
                "zip": "0756",
                "pinyin": "Zhuhai",
                "name": "珠海",
                "label": "珠海Zhuhai0756"
            },
            {
                "zip": "0623",
                "pinyin": "Zaozhuang",
                "name": "枣庄",
                "label": "枣庄Zaozhuang0623"
            },
            {
                "zip": "0744",
                "pinyin": "Zhangjiajie",
                "name": "张家界",
                "label": "张家界Zhangjiajie0744"
            },
            {
                "zip": "0313",
                "pinyin": "Zhangjiakou",
                "name": "张家口",
                "label": "张家口Zhangjiakou0313"
            },
            {
                "zip": "0936",
                "pinyin": "Zhangye",
                "name": "张掖",
                "label": "张掖Zhangye0936"
            },
            {
                "zip": "0759",
                "pinyin": "Zhanjiang",
                "name": "湛江",
                "label": "湛江Zhanjiang0759"
            },
            {
                "zip": "0758",
                "pinyin": "Zhaoqing",
                "name": "肇庆",
                "label": "肇庆Zhaoqing0758"
            },
            {
                "zip": "0870",
                "pinyin": "Zhaotong",
                "name": "昭通",
                "label": "昭通Zhaotong0870"
            },
            {
                "zip": "0511",
                "pinyin": "Zhenjiang",
                "name": "镇江",
                "label": "镇江Zhenjiang0511"
            },
            {
                "zip": "0955",
                "pinyin": "Zhongwei",
                "name": "中卫",
                "label": "中卫Zhongwei0955"
            },
            {
                "zip": "0394",
                "pinyin": "Zhoukou",
                "name": "周口",
                "label": "周口Zhoukou0394"
            },
            {
                "zip": "0580",
                "pinyin": "Zhoushan",
                "name": "舟山",
                "label": "舟山Zhoushan0580"
            },
            {
                "zip": "0396",
                "pinyin": "Zhumadian",
                "name": "驻马店",
                "label": "驻马店Zhumadian0396"
            },
            {
                "zip": "0731",
                "pinyin": "Zhuzhou",
                "name": "株洲",
                "label": "株洲Zhuzhou0731"
            },
            {
                "zip": "0533",
                "pinyin": "Zibo",
                "name": "淄博",
                "label": "淄博Zibo0533"
            },
            {
                "zip": "0813",
                "pinyin": "Zigong",
                "name": "自贡",
                "label": "自贡Zigong0813"
            },
            {
                "zip": "028",
                "pinyin": "Ziyang",
                "name": "资阳",
                "label": "资阳Ziyang028"
            },
            {
                "zip": "0852",
                "pinyin": "Zunyi",
                "name": "遵义",
                "label": "遵义Zunyi0852"
            },
            {
                "zip": "0311",
                "pinyin": "Zanhuang",
                "name": "赞皇",
                "label": "赞皇Zanhuang0311"
            },
            {
                "zip": "020",
                "pinyin": "Zengcheng",
                "name": "增城",
                "label": "增城Zengcheng020"
            },
            {
                "zip": "0512",
                "pinyin": "Zhangjiagang",
                "name": "张家港",
                "label": "张家港Zhangjiagang0512"
            },
            {
                "zip": "0597",
                "pinyin": "Zhangping",
                "name": "漳平",
                "label": "漳平Zhangping0597"
            },
            {
                "zip": "0596",
                "pinyin": "Zhangpu",
                "name": "漳浦",
                "label": "漳浦Zhangpu0596"
            },
            {
                "zip": "0531",
                "pinyin": "Zhangqiu",
                "name": "章丘",
                "label": "章丘Zhangqiu0531"
            },
            {
                "zip": "0795",
                "pinyin": "Zhangshu",
                "name": "樟树",
                "label": "樟树Zhangshu0795"
            },
            {
                "zip": "0543",
                "pinyin": "Zhanhua",
                "name": "沾化",
                "label": "沾化Zhanhua0543"
            },
            {
                "zip": "0311",
                "pinyin": "Zhaoxian",
                "name": "赵县",
                "label": "赵县Zhaoxian0311"
            },
            {
                "zip": "0535",
                "pinyin": "Zhaoyuan",
                "name": "招远",
                "label": "招远Zhaoyuan0535"
            },
            {
                "zip": "0311",
                "pinyin": "Zhengding",
                "name": "正定",
                "label": "正定Zhengding0311"
            },
            {
                "zip": "0599",
                "pinyin": "Zhenghe",
                "name": "政和",
                "label": "政和Zhenghe0599"
            },
            {
                "zip": "0593",
                "pinyin": "Zherong",
                "name": "柘荣",
                "label": "柘荣Zherong0593"
            },
            {
                "zip": "0371",
                "pinyin": "Zhongmou",
                "name": "中牟",
                "label": "中牟Zhongmou0371"
            },
            {
                "zip": "023",
                "pinyin": "Zhongxian",
                "name": "忠县",
                "label": "忠县Zhongxian023"
            },
            {
                "zip": "0593",
                "pinyin": "Zhouning",
                "name": "周宁",
                "label": "周宁Zhouning0593"
            },
            {
                "zip": "029",
                "pinyin": "Zhouzhi",
                "name": "周至",
                "label": "周至Zhouzhi029"
            },
            {
                "zip": "0411",
                "pinyin": "Zhuanghe",
                "name": "庄河",
                "label": "庄河Zhuanghe0411"
            },
            {
                "zip": "0536",
                "pinyin": "Zhucheng",
                "name": "诸城",
                "label": "诸城Zhucheng0536"
            },
            {
                "zip": "0575",
                "pinyin": "Zhuji",
                "name": "诸暨",
                "label": "诸暨Zhuji0575"
            },
            {
                "zip": "0762",
                "pinyin": "Zijin",
                "name": "紫金",
                "label": "紫金Zijin0762"
            },
            {
                "zip": "0794",
                "pinyin": "Zixi",
                "name": "资溪",
                "label": "资溪Zixi0794"
            },
            {
                "zip": "0537",
                "pinyin": "Zoucheng",
                "name": "邹城",
                "label": "邹城Zoucheng0537"
            },
            {
                "zip": "0543",
                "pinyin": "Zouping",
                "name": "邹平",
                "label": "邹平Zouping0543"
            },
            {
                "zip": "0315",
                "pinyin": "Zunhua",
                "name": "遵化",
                "label": "遵化Zunhua0315"
            }
        ]
    }
]
}
